export const NigeriaStatesInfo = [
  { id: 1, value: "Abia", label: "Abia" },
  { id: 2, value: "Adamawa", label: "Adamawa" },
  { id: 3, value: "Akwa Ibom", label: "Akwa Ibom" },
  { id: 4, value: "Anambra", label: "Anambra" },
  { id: 5, value: "Bauchi", label: "Bauchi" },
  { id: 6, value: "Bayelsa", label: "Bayelsa" },
  { id: 7, value: "Benue", label: "Benue" },
  { id: 8, value: "Borno", label: "Borno" },
  { id: 9, value: "Cross River", label: "Cross River" },
  { id: 10, value: "Delta", label: "Delta" },
  { id: 11, value: "Ebonyi", label: "Ebonyi" },
  { id: 12, value: "Edo", label: "Edo" },
  { id: 13, value: "Ekiti", label: "Ekiti" },
  { id: 14, value: "Enugu", label: "Enugu" },
  { id: 15, value: "FCT", label: "FCT" },
  { id: 16, value: "Gombe", label: "Gombe" },
  { id: 17, value: "Imo", label: "Imo" },
  { id: 18, value: "Jigawa", label: "Jigawa" },
  { id: 19, value: "Kaduna", label: "Kaduna" },
  { id: 20, value: "Kano", label: "Kano" },
  { id: 21, value: "Katsina", label: "Katsina" },
  { id: 22, value: "Kebbi", label: "Kebbi" },
  { id: 23, value: "Kogi", label: "Kogi" },
  { id: 24, value: "Kwara", label: "Kwara" },
  { id: 25, value: "Lagos", label: "Lagos" },
  { id: 26, value: "Nasarawa", label: "Nasarawa" },
  { id: 27, value: "Niger", label: "Niger" },
  { id: 28, value: "Ogun", label: "Ogun" },
  { id: 29, value: "Ondo", label: "Ondo" },
  { id: 30, value: "Osun", label: "Osun" },
  { id: 31, value: "Oyo", label: "Oyo" },
  { id: 32, value: "Plateau", label: "Plateau" },
  { id: 33, value: "Rivers", label: "Rivers" },
  { id: 34, value: "Sokoto", label: "Sokoto" },
  { id: 35, value: "Taraba", label: "Taraba" },
  { id: 36, value: "Yobe", label: "Yobe" },
  { id: 37, value: "Zamfara", label: "Zamfara" },
];

export const QuestionSetInfo = [
  {
    value: "MCQ Set- 1 for police constable",
    label: "MCQ Set- 1 for police constable",
  },
  {
    value: "MCQ Set - 1 for Cadet Sub Inspector",
    label: "MCQ Set - 1 for Cadet Sub Inspector",
  },
  { value: "MCQ Set - 1 for Cadet ASP", label: "MCQ Set - 1 for Cadet ASP" },
];

export const TitleInfo = [
  { value: "Mr", label: "Mr" },
  { value: "Mrs", label: "Mrs" },
  { value: "Ms", label: "Ms" },
  { value: "Miss", label: "Miss" },
];

export const GenderInfo = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];


export const MaritalStatusInfo = [
  { value: "Single", label: "Single" },
  { value: "Married", label: "Married" },
  { value: "Divorced", label: "Divorced" },
  { value: "Separated ", label: "Separated " },
  { value: "Widowed ", label: "Widowed " },
];


export const NigeriaReligions = [
  { value: "Christianity", label: "Christianity" },
  { value: "Islam", label: "Islam" },
  { value: "Traditional Religion", label: "Traditional Religion" },
  { value: "Other", label: "Other" },
];

export const EducationQualificationsInfo = [
  {
    id: 1,
    value: "First School Leaving Certificate (FSLC)",
    label: "First School Leaving Certificate (FSLC)",
    level: "Primary Education",
    subjects: [
      { value: "English", label: "English" },
      { value: "Mathematics", label: "Mathematics" },
      { value: "Basic Science", label: "Basic Science" },
      { value: "Social Studies", label: "Social Studies" },
    ],
  },
  {
    id: 2,
    value: "West African Senior School Certificate (WASSCE)",
    label: "West African Senior School Certificate (WASSCE)",
    level: "Senior Secondary Education",
    subjects: [
      { value: "Mathematics", label: "Mathematics" },
      { value: "English", label: "English" },
      { value: "Biology", label: "Biology" },
      { value: "Chemistry", label: "Chemistry" },
      { value: "Physics", label: "Physics" },
      { value: "Economics", label: "Economics" },
      { value: "Literature", label: "Literature" },
    ],
  },
  {
    id: 3,
    value: "National Examination Council (NECO) Certificate",
    label: "National Examination Council (NECO) Certificate",
    level: "Senior Secondary Education",
    subjects: [
      { value: "Mathematics", label: "Mathematics" },
      { value: "English", label: "English" },
      { value: "Agriculture", label: "Agriculture" },
      { value: "Commerce", label: "Commerce" },
      { value: "Government", label: "Government" },
      { value: "Physics", label: "Physics" },
    ],
  },
  {
    id: 4,
    value: "National Diploma (ND)",
    label: "National Diploma (ND)",
    level: "Tertiary Education",
    subjects: [
      { value: "Engineering", label: "Engineering" },
      { value: "Business Studies", label: "Business Studies" },
      { value: "Computer Science", label: "Computer Science" },
      { value: "Mass Communication", label: "Mass Communication" },
    ],
  },
  {
    id: 5,
    value: "Higher National Diploma (HND)",
    label: "Higher National Diploma (HND)",
    level: "Tertiary Education",
    subjects: [
      { value: "Electrical Engineering", label: "Electrical Engineering" },
      { value: "Mechanical Engineering", label: "Mechanical Engineering" },
      { value: "Accounting", label: "Accounting" },
      { value: "Marketing", label: "Marketing" },
    ],
  },
  {
    id: 6,
    value: "Bachelor of Science (B.Sc.)",
    label: "Bachelor of Science (B.Sc.)",
    level: "Tertiary Education",
    subjects: [
      { value: "Computer Science", label: "Computer Science" },
      { value: "Mathematics", label: "Mathematics" },
      { value: "Physics", label: "Physics" },
      { value: "Biology", label: "Biology" },
      { value: "Chemistry", label: "Chemistry" },
    ],
  },
  {
    id: 7,
    value: "Bachelor of Arts (B.A.)",
    label: "Bachelor of Arts (B.A.)",
    level: "Tertiary Education",
    subjects: [
      { value: "History", label: "History" },
      { value: "English", label: "English" },
      { value: "Philosophy", label: "Philosophy" },
      { value: "Literature", label: "Literature" },
      { value: "Linguistics", label: "Linguistics" },
    ],
  },
  {
    id: 8,
    value: "National Certificate in Education (NCE)",
    label: "National Certificate in Education (NCE)",
    level: "Tertiary Education",
    subjects: [
      { value: "Education", label: "Education" },
      { value: "English", label: "English" },
      { value: "Mathematics", label: "Mathematics" },
      { value: "Biology", label: "Biology" },
    ],
  },
  {
    id: 9,
    value: "Postgraduate Diploma (PGD)",
    label: "Postgraduate Diploma (PGD)",
    level: "Postgraduate Education",
    subjects: [
      { value: "Management", label: "Management" },
      { value: "Education", label: "Education" },
      { value: "Public Administration", label: "Public Administration" },
    ],
  },
  {
    id: 10,
    value: "Master of Science (M.Sc.)",
    label: "Master of Science (M.Sc.)",
    level: "Postgraduate Education",
    subjects: [
      { value: "Biotechnology", label: "Biotechnology" },
      { value: "Data Science", label: "Data Science" },
      { value: "Environmental Science", label: "Environmental Science" },
    ],
  },
  {
    id: 11,
    value: "Master of Arts (M.A.)",
    label: "Master of Arts (M.A.)",
    level: "Postgraduate Education",
    subjects: [
      { value: "Creative Writing", label: "Creative Writing" },
      { value: "Philosophy", label: "Philosophy" },
      { value: "Cultural Studies", label: "Cultural Studies" },
    ],
  },
  {
    id: 12,
    value: "Doctor of Philosophy (PhD)",
    label: "Doctor of Philosophy (PhD)",
    level: "Postgraduate Education",
    subjects: [
      { value: "Artificial Intelligence", label: "Artificial Intelligence" },
      { value: "Theoretical Physics", label: "Theoretical Physics" },
      { value: "Psychology", label: "Psychology" },
      { value: "Sociology", label: "Sociology" },
    ],
  },
];


export const subjects = [
  { value: "Mathematics", label: "Mathematics" },
  { value: "English", label: "English" },
  { value: "Biology", label: "Biology" },
  { value: "Chemistry", label: "Chemistry" },
  { value: "Physics", label: "Physics" },
  { value: "Economics", label: "Economics" },
  { value: "Literature", label: "Literature" },
];

export const GradesInfo = [
  { value: "A1", label: "A1" },
  { value: "B2", label: "B2" },
  { value: "B3", label: "B3" },
  { value: "C4", label: "C4" },
  { value: "C5", label: "C5" },
  { value: "C6", label: "C6" },
  { value: "D7", label: "D7" },
  { value: "E8", label: "E8" },
  { value: "F9", label: "F9" },
];

export const LocalGovernmentAreaInfo = [
  // ABIA
  { value: "Aba North", label: "Aba North", state: "Abia" },
  { value: "Aba South", label: "Aba South", state: "Abia" },
  { value: "Arochukwu", label: "Arochukwu", state: "Abia" },
  { value: "Bende", label: "Bende", state: "Abia" },
  { value: "Ikwuano", label: "Ikwuano", state: "Abia" },
  { value: "Isiala Ngwa North", label: "Isiala Ngwa North", state: "Abia" },
  { value: "Isiala Ngwa South", label: "Isiala Ngwa South", state: "Abia" },
  { value: "Isuikwuato", label: "Isuikwuato", state: "Abia" },
  { value: "Obi Ngwa", label: "Obi Ngwa", state: "Abia" },
  { value: "Ohafia", label: "Ohafia", state: "Abia" },
  { value: "Osisioma", label: "Osisioma", state: "Abia" },
  { value: "Ugwunagbo", label: "Ugwunagbo", state: "Abia" },
  { value: "Ukwa East", label: "Ukwa East", state: "Abia" },
  { value: "Ukwa West", label: "Ukwa West", state: "Abia" },
  { value: "Umuahia North", label: "Umuahia North", state: "Abia" },
  { value: "Umuahia South", label: "Umuahia South", state: "Abia" },
  { value: "Umu Nneochi", label: "Umu Nneochi", state: "Abia" },

  // ADAMAWA
  { value: "Demsa", label: "Demsa", state: "Adamawa" },
  { value: "Fufore", label: "Fufore", state: "Adamawa" },
  { value: "Ganye", label: "Ganye", state: "Adamawa" },
  { value: "Girei", label: "Girei", state: "Adamawa" },
  { value: "Gombi", label: "Gombi", state: "Adamawa" },
  { value: "Guyuk", label: "Guyuk", state: "Adamawa" },
  { value: "Hong", label: "Hong", state: "Adamawa" },
  { value: "Jada", label: "Jada", state: "Adamawa" },
  { value: "Lamurde", label: "Lamurde", state: "Adamawa" },
  { value: "Madagali", label: "Madagali", state: "Adamawa" },
  { value: "Maiha", label: "Maiha", state: "Adamawa" },
  { value: "Mayo Belwa", label: "Mayo Belwa", state: "Adamawa" },
  { value: "Michika", label: "Michika", state: "Adamawa" },
  { value: "Mubi North", label: "Mubi North", state: "Adamawa" },
  { value: "Mubi South", label: "Mubi South", state: "Adamawa" },
  { value: "Numan", label: "Numan", state: "Adamawa" },
  { value: "Shelleng", label: "Shelleng", state: "Adamawa" },
  { value: "Song", label: "Song", state: "Adamawa" },
  { value: "Toungo", label: "Toungo", state: "Adamawa" },
  { value: "Yola North", label: "Yola North", state: "Adamawa" },
  { value: "Yola South", label: "Yola South", state: "Adamawa" },

  // AKWA IBOM
  { value: "Abak", label: "Abak", state: "Akwa Ibom" },
  { value: "Eastern Obolo", label: "Eastern Obolo", state: "Akwa Ibom" },
  { value: "Eket", label: "Eket", state: "Akwa Ibom" },
  { value: "Esit Eket", label: "Esit Eket", state: "Akwa Ibom" },
  { value: "Essien Udim", label: "Essien Udim", state: "Akwa Ibom" },
  { value: "Etim Ekpo", label: "Etim Ekpo", state: "Akwa Ibom" },
  { value: "Etinan", label: "Etinan", state: "Akwa Ibom" },
  { value: "Ibeno", label: "Ibeno", state: "Akwa Ibom" },
  { value: "Ibesikpo Asutan", label: "Ibesikpo Asutan", state: "Akwa Ibom" },
  { value: "Ibiono Ibom", label: "Ibiono Ibom", state: "Akwa Ibom" },
  { value: "Ika", label: "Ika", state: "Akwa Ibom" },
  { value: "Ikono", label: "Ikono", state: "Akwa Ibom" },
  { value: "Ikot Abasi", label: "Ikot Abasi", state: "Akwa Ibom" },
  { value: "Ikot Ekpene", label: "Ikot Ekpene", state: "Akwa Ibom" },
  { value: "Ini", label: "Ini", state: "Akwa Ibom" },
  { value: "Itu", label: "Itu", state: "Akwa Ibom" },
  { value: "Mbo", label: "Mbo", state: "Akwa Ibom" },
  { value: "Mkpat Enin", label: "Mkpat Enin", state: "Akwa Ibom" },
  { value: "Nsit Atai", label: "Nsit Atai", state: "Akwa Ibom" },
  { value: "Nsit Ibom", label: "Nsit Ibom", state: "Akwa Ibom" },
  { value: "Nsit Ubium", label: "Nsit Ubium", state: "Akwa Ibom" },
  { value: "Obot Akara", label: "Obot Akara", state: "Akwa Ibom" },
  { value: "Okobo", label: "Okobo", state: "Akwa Ibom" },
  { value: "Onna", label: "Onna", state: "Akwa Ibom" },
  { value: "Oron", label: "Oron", state: "Akwa Ibom" },
  { value: "Oruk Anam", label: "Oruk Anam", state: "Akwa Ibom" },
  { value: "Udung Uko", label: "Udung Uko", state: "Akwa Ibom" },
  { value: "Ukanafun", label: "Ukanafun", state: "Akwa Ibom" },
  { value: "Uruan", label: "Uruan", state: "Akwa Ibom" },
  { value: "Urue Offong/Oruko", label: "Urue Offong/Oruko", state: "Akwa Ibom" },
  { value: "Uyo", label: "Uyo", state: "Akwa Ibom" },

  // ANAMBRA
  { value: "Aguata", label: "Aguata", state: "Anambra" },
  { value: "Anambra East", label: "Anambra East", state: "Anambra" },
  { value: "Anambra West", label: "Anambra West", state: "Anambra" },
  { value: "Anaocha", label: "Anaocha", state: "Anambra" },
  { value: "Awka North", label: "Awka North", state: "Anambra" },
  { value: "Awka South", label: "Awka South", state: "Anambra" },
  { value: "Ayamelum", label: "Ayamelum", state: "Anambra" },
  { value: "Dunukofia", label: "Dunukofia", state: "Anambra" },
  { value: "Ekwusigo", label: "Ekwusigo", state: "Anambra" },
  { value: "Idemili North", label: "Idemili North", state: "Anambra" },
  { value: "Idemili South", label: "Idemili South", state: "Anambra" },
  { value: "Ihiala", label: "Ihiala", state: "Anambra" },
  { value: "Njikoka", label: "Njikoka", state: "Anambra" },
  { value: "Nnewi North", label: "Nnewi North", state: "Anambra" },
  { value: "Nnewi South", label: "Nnewi South", state: "Anambra" },
  { value: "Ogbaru", label: "Ogbaru", state: "Anambra" },
  { value: "Onitsha North", label: "Onitsha North", state: "Anambra" },
  { value: "Onitsha South", label: "Onitsha South", state: "Anambra" },
  { value: "Orumba North", label: "Orumba North", state: "Anambra" },
  { value: "Orumba South", label: "Orumba South", state: "Anambra" },
  { value: "Oyi", label: "Oyi", state: "Anambra" },

  // BAUCHI
  { value: "Alkaleri", label: "Alkaleri", state: "Bauchi" },
  { value: "Bauchi", label: "Bauchi", state: "Bauchi" },
  { value: "Bogoro", label: "Bogoro", state: "Bauchi" },
  { value: "Damban", label: "Damban", state: "Bauchi" },
  { value: "Darazo", label: "Darazo", state: "Bauchi" },
  { value: "Dass", label: "Dass", state: "Bauchi" },
  { value: "Gamawa", label: "Gamawa", state: "Bauchi" },
  { value: "Ganjuwa", label: "Ganjuwa", state: "Bauchi" },
  { value: "Giade", label: "Giade", state: "Bauchi" },
  { value: "Itas/Gadau", label: "Itas/Gadau", state: "Bauchi" },
  { value: "Jama'are", label: "Jama'are", state: "Bauchi" },
  { value: "Katagum", label: "Katagum", state: "Bauchi" },
  { value: "Kirfi", label: "Kirfi", state: "Bauchi" },
  { value: "Misau", label: "Misau", state: "Bauchi" },
  { value: "Ningi", label: "Ningi", state: "Bauchi" },
  { value: "Shira", label: "Shira", state: "Bauchi" },
  { value: "Tafawa Balewa", label: "Tafawa Balewa", state: "Bauchi" },
  { value: "Toro", label: "Toro", state: "Bauchi" },
  { value: "Warji", label: "Warji", state: "Bauchi" },
  { value: "Zaki", label: "Zaki", state: "Bauchi" },

  // BAYELSA
  { value: "Brass", label: "Brass", state: "Bayelsa" },
  { value: "Ekeremor", label: "Ekeremor", state: "Bayelsa" },
  { value: "Kolokuma/Opokuma", label: "Kolokuma/Opokuma", state: "Bayelsa" },
  { value: "Nembe", label: "Nembe", state: "Bayelsa" },
  { value: "Ogbia", label: "Ogbia", state: "Bayelsa" },
  { value: "Sagbama", label: "Sagbama", state: "Bayelsa" },
  { value: "Southern Ijaw", label: "Southern Ijaw", state: "Bayelsa" },
  { value: "Yenagoa", label: "Yenagoa", state: "Bayelsa" },

  // BENUE
  { value: "Ado", label: "Ado", state: "Benue" },
  { value: "Agatu", label: "Agatu", state: "Benue" },
  { value: "Apa", label: "Apa", state: "Benue" },
  { value: "Buruku", label: "Buruku", state: "Benue" },
  { value: "Gboko", label: "Gboko", state: "Benue" },
  { value: "Guma", label: "Guma", state: "Benue" },
  { value: "Gwer East", label: "Gwer East", state: "Benue" },
  { value: "Gwer West", label: "Gwer West", state: "Benue" },
  { value: "Katsina-Ala", label: "Katsina-Ala", state: "Benue" },
  { value: "Konshisha", label: "Konshisha", state: "Benue" },
  { value: "Kwande", label: "Kwande", state: "Benue" },
  { value: "Logo", label: "Logo", state: "Benue" },
  { value: "Makurdi", label: "Makurdi", state: "Benue" },
  { value: "Obi", label: "Obi", state: "Benue" },
  { value: "Ogbadibo", label: "Ogbadibo", state: "Benue" },
  { value: "Ohimini", label: "Ohimini", state: "Benue" },
  { value: "Oju", label: "Oju", state: "Benue" },
  { value: "Okpokwu", label: "Okpokwu", state: "Benue" },
  { value: "Otukpo", label: "Otukpo", state: "Benue" },
  { value: "Tarka", label: "Tarka", state: "Benue" },
  { value: "Ukum", label: "Ukum", state: "Benue" },
  { value: "Ushongo", label: "Ushongo", state: "Benue" },
  { value: "Vandeikya", label: "Vandeikya", state: "Benue" },

  // BORNO
  { value: "Abadam", label: "Abadam", state: "Borno" },
  { value: "Askira/Uba", label: "Askira/Uba", state: "Borno" },
  { value: "Bama", label: "Bama", state: "Borno" },
  { value: "Bayo", label: "Bayo", state: "Borno" },
  { value: "Biu", label: "Biu", state: "Borno" },
  { value: "Chibok", label: "Chibok", state: "Borno" },
  { value: "Damboa", label: "Damboa", state: "Borno" },
  { value: "Dikwa", label: "Dikwa", state: "Borno" },
  { value: "Gubio", label: "Gubio", state: "Borno" },
  { value: "Guzamala", label: "Guzamala", state: "Borno" },
  { value: "Gwoza", label: "Gwoza", state: "Borno" },
  { value: "Hawul", label: "Hawul", state: "Borno" },
  { value: "Jere", label: "Jere", state: "Borno" },
  { value: "Kaga", label: "Kaga", state: "Borno" },
  { value: "Kala/Balge", label: "Kala/Balge", state: "Borno" },
  { value: "Konduga", label: "Konduga", state: "Borno" },
  { value: "Kukawa", label: "Kukawa", state: "Borno" },
  { value: "Kwaya Kusar", label: "Kwaya Kusar", state: "Borno" },
  { value: "Mafa", label: "Mafa", state: "Borno" },
  { value: "Magumeri", label: "Magumeri", state: "Borno" },
  { value: "Maiduguri", label: "Maiduguri", state: "Borno" },
  { value: "Marte", label: "Marte", state: "Borno" },
  { value: "Mobbar", label: "Mobbar", state: "Borno" },
  { value: "Monguno", label: "Monguno", state: "Borno" },
  { value: "Ngala", label: "Ngala", state: "Borno" },
  { value: "Nganzai", label: "Nganzai", state: "Borno" },
  { value: "Shani", label: "Shani", state: "Borno" },

  // CROSS RIVER
  { value: "Abi", label: "Abi", state: "Cross River" },
  { value: "Akamkpa", label: "Akamkpa", state: "Cross River" },
  { value: "Akpabuyo", label: "Akpabuyo", state: "Cross River" },
  { value: "Bakassi", label: "Bakassi", state: "Cross River" },
  { value: "Bekwarra", label: "Bekwarra", state: "Cross River" },
  { value: "Biase", label: "Biase", state: "Cross River" },
  { value: "Boki", label: "Boki", state: "Cross River" },
  { value: "Calabar Municipal", label: "Calabar Municipal", state: "Cross River" },
  { value: "Calabar South", label: "Calabar South", state: "Cross River" },
  { value: "Etung", label: "Etung", state: "Cross River" },
  { value: "Ikom", label: "Ikom", state: "Cross River" },
  { value: "Obanliku", label: "Obanliku", state: "Cross River" },
  { value: "Obubra", label: "Obubra", state: "Cross River" },
  { value: "Obudu", label: "Obudu", state: "Cross River" },
  { value: "Odukpani", label: "Odukpani", state: "Cross River" },
  { value: "Ogoja", label: "Ogoja", state: "Cross River" },
  { value: "Yakurr", label: "Yakurr", state: "Cross River" },
  { value: "Yala", label: "Yala", state: "Cross River" },

  // DELTA
  { value: "Aniocha North", label: "Aniocha North", state: "Delta" },
  { value: "Aniocha South", label: "Aniocha South", state: "Delta" },
  { value: "Bomadi", label: "Bomadi", state: "Delta" },
  { value: "Burutu", label: "Burutu", state: "Delta" },
  { value: "Ethiope East", label: "Ethiope East", state: "Delta" },
  { value: "Ethiope West", label: "Ethiope West", state: "Delta" },
  { value: "Ika North East", label: "Ika North East", state: "Delta" },
  { value: "Ika South", label: "Ika South", state: "Delta" },
  { value: "Isoko North", label: "Isoko North", state: "Delta" },
  { value: "Isoko South", label: "Isoko South", state: "Delta" },
  { value: "Ndokwa East", label: "Ndokwa East", state: "Delta" },
  { value: "Ndokwa West", label: "Ndokwa West", state: "Delta" },
  { value: "Okpe", label: "Okpe", state: "Delta" },
  { value: "Oshimili North", label: "Oshimili North", state: "Delta" },
  { value: "Oshimili South", label: "Oshimili South", state: "Delta" },
  { value: "Patani", label: "Patani", state: "Delta" },
  { value: "Sapele", label: "Sapele", state: "Delta" },
  { value: "Udu", label: "Udu", state: "Delta" },
  { value: "Ughelli North", label: "Ughelli North", state: "Delta" },
  { value: "Ughelli South", label: "Ughelli South", state: "Delta" },
  { value: "Ukwuani", label: "Ukwuani", state: "Delta" },
  { value: "Uvwie", label: "Uvwie", state: "Delta" },
  { value: "Warri North", label: "Warri North", state: "Delta" },
  { value: "Warri South", label: "Warri South", state: "Delta" },
  { value: "Warri South West", label: "Warri South West", state: "Delta" },

  // EBONYI
  { value: "Abakaliki", label: "Abakaliki", state: "Ebonyi" },
  { value: "Afikpo North", label: "Afikpo North", state: "Ebonyi" },
  { value: "Afikpo South", label: "Afikpo South", state: "Ebonyi" },
  { value: "Ebonyi", label: "Ebonyi", state: "Ebonyi" },
  { value: "Ezza North", label: "Ezza North", state: "Ebonyi" },
  { value: "Ezza South", label: "Ezza South", state: "Ebonyi" },
  { value: "Ikwo", label: "Ikwo", state: "Ebonyi" },
  { value: "Ishielu", label: "Ishielu", state: "Ebonyi" },
  { value: "Ivo", label: "Ivo", state: "Ebonyi" },
  { value: "Izzi", label: "Izzi", state: "Ebonyi" },
  { value: "Ohaozara", label: "Ohaozara", state: "Ebonyi" },
  { value: "Ohaukwu", label: "Ohaukwu", state: "Ebonyi" },
  { value: "Onicha", label: "Onicha", state: "Ebonyi" },

  // EDO
  { value: "Akoko-Edo", label: "Akoko-Edo", state: "Edo" },
  { value: "Egor", label: "Egor", state: "Edo" },
  { value: "Esan Central", label: "Esan Central", state: "Edo" },
  { value: "Esan North-East", label: "Esan North-East", state: "Edo" },
  { value: "Esan South-East", label: "Esan South-East", state: "Edo" },
  { value: "Esan West", label: "Esan West", state: "Edo" },
  { value: "Etsako Central", label: "Etsako Central", state: "Edo" },
  { value: "Etsako East", label: "Etsako East", state: "Edo" },
  { value: "Etsako West", label: "Etsako West", state: "Edo" },
  { value: "Igueben", label: "Igueben", state: "Edo" },
  { value: "Ikpoba-Okha", label: "Ikpoba-Okha", state: "Edo" },
  { value: "Orhionmwon", label: "Orhionmwon", state: "Edo" },
  { value: "Oredo", label: "Oredo", state: "Edo" },
  { value: "Ovia North-East", label: "Ovia North-East", state: "Edo" },
  { value: "Ovia South-West", label: "Ovia South-West", state: "Edo" },
  { value: "Owan East", label: "Owan East", state: "Edo" },
  { value: "Owan West", label: "Owan West", state: "Edo" },
  { value: "Uhunmwonde", label: "Uhunmwonde", state: "Edo" },

  // EKITI
  { value: "Ado Ekiti", label: "Ado Ekiti", state: "Ekiti" },
  { value: "Efon", label: "Efon", state: "Ekiti" },
  { value: "Ekiti East", label: "Ekiti East", state: "Ekiti" },
  { value: "Ekiti South-West", label: "Ekiti South-West", state: "Ekiti" },
  { value: "Ekiti West", label: "Ekiti West", state: "Ekiti" },
  { value: "Emure", label: "Emure", state: "Ekiti" },
  { value: "Gbonyin", label: "Gbonyin", state: "Ekiti" },
  { value: "Ido Osi", label: "Ido Osi", state: "Ekiti" },
  { value: "Ijero", label: "Ijero", state: "Ekiti" },
  { value: "Ikere", label: "Ikere", state: "Ekiti" },
  { value: "Ikole", label: "Ikole", state: "Ekiti" },
  { value: "Ilejemeje", label: "Ilejemeje", state: "Ekiti" },
  { value: "Irepodun/Ifelodun", label: "Irepodun/Ifelodun", state: "Ekiti" },
  { value: "Ise/Orun", label: "Ise/Orun", state: "Ekiti" },
  { value: "Moba", label: "Moba", state: "Ekiti" },
  { value: "Oye", label: "Oye", state: "Ekiti" },

  // ENUGU
  { value: "Aninri", label: "Aninri", state: "Enugu" },
  { value: "Awgu", label: "Awgu", state: "Enugu" },
  { value: "Enugu East", label: "Enugu East", state: "Enugu" },
  { value: "Enugu North", label: "Enugu North", state: "Enugu" },
  { value: "Enugu South", label: "Enugu South", state: "Enugu" },
  { value: "Ezeagu", label: "Ezeagu", state: "Enugu" },
  { value: "Igbo Etiti", label: "Igbo Etiti", state: "Enugu" },
  { value: "Igbo Eze North", label: "Igbo Eze North", state: "Enugu" },
  { value: "Igbo Eze South", label: "Igbo Eze South", state: "Enugu" },
  { value: "Isi Uzo", label: "Isi Uzo", state: "Enugu" },
  { value: "Nkanu East", label: "Nkanu East", state: "Enugu" },
  { value: "Nkanu West", label: "Nkanu West", state: "Enugu" },
  { value: "Nsukka", label: "Nsukka", state: "Enugu" },
  { value: "Oji River", label: "Oji River", state: "Enugu" },
  { value: "Udenu", label: "Udenu", state: "Enugu" },
  { value: "Udi", label: "Udi", state: "Enugu" },
  { value: "Uzo Uwani", label: "Uzo Uwani", state: "Enugu" },

  // FCT
  { value: "Abaji", label: "Abaji", state: "FCT" },
  { value: "Bwari", label: "Bwari", state: "FCT" },
  { value: "Gwagwalada", label: "Gwagwalada", state: "FCT" },
  { value: "Kuje", label: "Kuje", state: "FCT" },
  { value: "Kwali", label: "Kwali", state: "FCT" },
  { value: "Municipal Area Council", label: "Municipal Area Council", state: "FCT" },

  // GOMBE
  { value: "Akko", label: "Akko", state: "Gombe" },
  { value: "Balanga", label: "Balanga", state: "Gombe" },
  { value: "Billiri", label: "Billiri", state: "Gombe" },
  { value: "Dukku", label: "Dukku", state: "Gombe" },
  { value: "Funakaye", label: "Funakaye", state: "Gombe" },
  { value: "Gombe", label: "Gombe", state: "Gombe" },
  { value: "Kaltungo", label: "Kaltungo", state: "Gombe" },
  { value: "Kwami", label: "Kwami", state: "Gombe" },
  { value: "Nafada", label: "Nafada", state: "Gombe" },
  { value: "Shongom", label: "Shongom", state: "Gombe" },
  { value: "Yamaltu/Deba", label: "Yamaltu/Deba", state: "Gombe" },

  // IMO
  { value: "Aboh Mbaise", label: "Aboh Mbaise", state: "Imo" },
  { value: "Ahiazu Mbaise", label: "Ahiazu Mbaise", state: "Imo" },
  { value: "Ehime Mbano", label: "Ehime Mbano", state: "Imo" },
  { value: "Ezinihitte", label: "Ezinihitte", state: "Imo" },
  { value: "Ideato North", label: "Ideato North", state: "Imo" },
  { value: "Ideato South", label: "Ideato South", state: "Imo" },
  { value: "Ihitte/Uboma", label: "Ihitte/Uboma", state: "Imo" },
  { value: "Ikeduru", label: "Ikeduru", state: "Imo" },
  { value: "Isiala Mbano", label: "Isiala Mbano", state: "Imo" },
  { value: "Isu", label: "Isu", state: "Imo" },
  { value: "Mbaitoli", label: "Mbaitoli", state: "Imo" },
  { value: "Ngor Okpala", label: "Ngor Okpala", state: "Imo" },
  { value: "Njaba", label: "Njaba", state: "Imo" },
  { value: "Nkwerre", label: "Nkwerre", state: "Imo" },
  { value: "Nwangele", label: "Nwangele", state: "Imo" },
  { value: "Obowo", label: "Obowo", state: "Imo" },
  { value: "Oguta", label: "Oguta", state: "Imo" },
  { value: "Ohaji/Egbema", label: "Ohaji/Egbema", state: "Imo" },
  { value: "Okigwe", label: "Okigwe", state: "Imo" },
  { value: "Onuimo", label: "Onuimo", state: "Imo" },
  { value: "Orlu", label: "Orlu", state: "Imo" },
  { value: "Orsu", label: "Orsu", state: "Imo" },
  { value: "Oru East", label: "Oru East", state: "Imo" },
  { value: "Oru West", label: "Oru West", state: "Imo" },
  { value: "Owerri Municipal", label: "Owerri Municipal", state: "Imo" },
  { value: "Owerri North", label: "Owerri North", state: "Imo" },
  { value: "Owerri South", label: "Owerri South", state: "Imo" },

  // JIGAWA
  { value: "Auyo", label: "Auyo", state: "Jigawa" },
  { value: "Babura", label: "Babura", state: "Jigawa" },
  { value: "Biriniwa", label: "Biriniwa", state: "Jigawa" },
  { value: "Birnin Kudu", label: "Birnin Kudu", state: "Jigawa" },
  { value: "Buji", label: "Buji", state: "Jigawa" },
  { value: "Dutse", label: "Dutse", state: "Jigawa" },
  { value: "Gagarawa", label: "Gagarawa", state: "Jigawa" },
  { value: "Garki", label: "Garki", state: "Jigawa" },
  { value: "Gumel", label: "Gumel", state: "Jigawa" },
  { value: "Guri", label: "Guri", state: "Jigawa" },
  { value: "Gwaram", label: "Gwaram", state: "Jigawa" },
  { value: "Gwiwa", label: "Gwiwa", state: "Jigawa" },
  { value: "Hadejia", label: "Hadejia", state: "Jigawa" },
  { value: "Jahun", label: "Jahun", state: "Jigawa" },
  { value: "Kafin Hausa", label: "Kafin Hausa", state: "Jigawa" },
  { value: "Kaugama", label: "Kaugama", state: "Jigawa" },
  { value: "Kazaure", label: "Kazaure", state: "Jigawa" },
  { value: "Kiri Kasama", label: "Kiri Kasama", state: "Jigawa" },
  { value: "Kiyawa", label: "Kiyawa", state: "Jigawa" },
  { value: "Maigatari", label: "Maigatari", state: "Jigawa" },
  { value: "Malam Madori", label: "Malam Madori", state: "Jigawa" },
  { value: "Miga", label: "Miga", state: "Jigawa" },
  { value: "Ringim", label: "Ringim", state: "Jigawa" },
  { value: "Roni", label: "Roni", state: "Jigawa" },
  { value: "Sule Tankarkar", label: "Sule Tankarkar", state: "Jigawa" },
  { value: "Taura", label: "Taura", state: "Jigawa" },
  { value: "Yankwashi", label: "Yankwashi", state: "Jigawa" },

  // KADUNA
  { value: "Birnin Gwari", label: "Birnin Gwari", state: "Kaduna" },
  { value: "Chikun", label: "Chikun", state: "Kaduna" },
  { value: "Giwa", label: "Giwa", state: "Kaduna" },
  { value: "Igabi", label: "Igabi", state: "Kaduna" },
  { value: "Ikara", label: "Ikara", state: "Kaduna" },
  { value: "Jaba", label: "Jaba", state: "Kaduna" },
  { value: "Jema'a", label: "Jema'a", state: "Kaduna" },
  { value: "Kachia", label: "Kachia", state: "Kaduna" },
  { value: "Kaduna North", label: "Kaduna North", state: "Kaduna" },
  { value: "Kaduna South", label: "Kaduna South", state: "Kaduna" },
  { value: "Kagarko", label: "Kagarko", state: "Kaduna" },
  { value: "Kajuru", label: "Kajuru", state: "Kaduna" },
  { value: "Kaura", label: "Kaura", state: "Kaduna" },
  { value: "Kauru", label: "Kauru", state: "Kaduna" },
  { value: "Kubau", label: "Kubau", state: "Kaduna" },
  { value: "Kudan", label: "Kudan", state: "Kaduna" },
  { value: "Lere", label: "Lere", state: "Kaduna" },
  { value: "Makarfi", label: "Makarfi", state: "Kaduna" },
  { value: "Sabon Gari", label: "Sabon Gari", state: "Kaduna" },
  { value: "Sanga", label: "Sanga", state: "Kaduna" },
  { value: "Soba", label: "Soba", state: "Kaduna" },
  { value: "Zangon Kataf", label: "Zangon Kataf", state: "Kaduna" },
  { value: "Zaria", label: "Zaria", state: "Kaduna" },

  // KANO
  { value: "Ajingi", label: "Ajingi", state: "Kano" },
  { value: "Albasu", label: "Albasu", state: "Kano" },
  { value: "Bagwai", label: "Bagwai", state: "Kano" },
  { value: "Bebeji", label: "Bebeji", state: "Kano" },
  { value: "Bichi", label: "Bichi", state: "Kano" },
  { value: "Bunkure", label: "Bunkure", state: "Kano" },
  { value: "Dala", label: "Dala", state: "Kano" },
  { value: "Dambatta", label: "Dambatta", state: "Kano" },
  { value: "Dawakin Kudu", label: "Dawakin Kudu", state: "Kano" },
  { value: "Dawakin Tofa", label: "Dawakin Tofa", state: "Kano" },
  { value: "Doguwa", label: "Doguwa", state: "Kano" },
  { value: "Fagge", label: "Fagge", state: "Kano" },
  { value: "Gabasawa", label: "Gabasawa", state: "Kano" },
  { value: "Garko", label: "Garko", state: "Kano" },
  { value: "Garun Mallam", label: "Garun Mallam", state: "Kano" },
  { value: "Gaya", label: "Gaya", state: "Kano" },
  { value: "Gezawa", label: "Gezawa", state: "Kano" },
  { value: "Gwale", label: "Gwale", state: "Kano" },
  { value: "Gwarzo", label: "Gwarzo", state: "Kano" },
  { value: "Kabo", label: "Kabo", state: "Kano" },
  { value: "Kano Municipal", label: "Kano Municipal", state: "Kano" },
  { value: "Karaye", label: "Karaye", state: "Kano" },
  { value: "Kibiya", label: "Kibiya", state: "Kano" },
  { value: "Kiru", label: "Kiru", state: "Kano" },
  { value: "Kumbotso", label: "Kumbotso", state: "Kano" },
  { value: "Kunchi", label: "Kunchi", state: "Kano" },
  { value: "Kura", label: "Kura", state: "Kano" },
  { value: "Madobi", label: "Madobi", state: "Kano" },
  { value: "Makoda", label: "Makoda", state: "Kano" },
  { value: "Minjibir", label: "Minjibir", state: "Kano" },
  { value: "Nasarawa", label: "Nasarawa", state: "Kano" },
  { value: "Rano", label: "Rano", state: "Kano" },
  { value: "Rimin Gado", label: "Rimin Gado", state: "Kano" },
  { value: "Rogo", label: "Rogo", state: "Kano" },
  { value: "Shanono", label: "Shanono", state: "Kano" },
  { value: "Sumaila", label: "Sumaila", state: "Kano" },
  { value: "Takai", label: "Takai", state: "Kano" },
  { value: "Tarauni", label: "Tarauni", state: "Kano" },
  { value: "Tofa", label: "Tofa", state: "Kano" },
  { value: "Tsanyawa", label: "Tsanyawa", state: "Kano" },
  { value: "Tudun Wada", label: "Tudun Wada", state: "Kano" },
  { value: "Ungogo", label: "Ungogo", state: "Kano" },
  { value: "Warawa", label: "Warawa", state: "Kano" },
  { value: "Wudil", label: "Wudil", state: "Kano" },

  // KATSINA
  { value: "Bakori", label: "Bakori", state: "Katsina" },
  { value: "Batagarawa", label: "Batagarawa", state: "Katsina" },
  { value: "Batsari", label: "Batsari", state: "Katsina" },
  { value: "Baure", label: "Baure", state: "Katsina" },
  { value: "Bindawa", label: "Bindawa", state: "Katsina" },
  { value: "Charanchi", label: "Charanchi", state: "Katsina" },
  { value: "Dandume", label: "Dandume", state: "Katsina" },
  { value: "Danja", label: "Danja", state: "Katsina" },
  { value: "Dan Musa", label: "Dan Musa", state: "Katsina" },
  { value: "Daura", label: "Daura", state: "Katsina" },
  { value: "Dutsi", label: "Dutsi", state: "Katsina" },
  { value: "Dutsin Ma", label: "Dutsin Ma", state: "Katsina" },
  { value: "Faskari", label: "Faskari", state: "Katsina" },
  { value: "Funtua", label: "Funtua", state: "Katsina" },
  { value: "Ingawa", label: "Ingawa", state: "Katsina" },
  { value: "Jibia", label: "Jibia", state: "Katsina" },
  { value: "Kafur", label: "Kafur", state: "Katsina" },
  { value: "Kaita", label: "Kaita", state: "Katsina" },
  { value: "Kankara", label: "Kankara", state: "Katsina" },
  { value: "Kankia", label: "Kankia", state: "Katsina" },
  { value: "Katsina", label: "Katsina", state: "Katsina" },
  { value: "Kurfi", label: "Kurfi", state: "Katsina" },
  { value: "Kusada", label: "Kusada", state: "Katsina" },
  { value: "Mai'Adua", label: "Mai'Adua", state: "Katsina" },
  { value: "Malumfashi", label: "Malumfashi", state: "Katsina" },
  { value: "Mani", label: "Mani", state: "Katsina" },
  { value: "Mashi", label: "Mashi", state: "Katsina" },
  { value: "Matazu", label: "Matazu", state: "Katsina" },
  { value: "Musawa", label: "Musawa", state: "Katsina" },
  { value: "Rimi", label: "Rimi", state: "Katsina" },
  { value: "Sabuwa", label: "Sabuwa", state: "Katsina" },
  { value: "Safana", label: "Safana", state: "Katsina" },
  { value: "Sandamu", label: "Sandamu", state: "Katsina" },
  { value: "Zango", label: "Zango", state: "Katsina" },

  // KEBBI
  { value: "Aleiro", label: "Aleiro", state: "Kebbi" },
  { value: "Arewa Dandi", label: "Arewa Dandi", state: "Kebbi" },
  { value: "Argungu", label: "Argungu", state: "Kebbi" },
  { value: "Augie", label: "Augie", state: "Kebbi" },
  { value: "Bagudo", label: "Bagudo", state: "Kebbi" },
  { value: "Birnin Kebbi", label: "Birnin Kebbi", state: "Kebbi" },
  { value: "Bunza", label: "Bunza", state: "Kebbi" },
  { value: "Dandi", label: "Dandi", state: "Kebbi" },
  { value: "Fakai", label: "Fakai", state: "Kebbi" },
  { value: "Gwandu", label: "Gwandu", state: "Kebbi" },
  { value: "Jega", label: "Jega", state: "Kebbi" },
  { value: "Kalgo", label: "Kalgo", state: "Kebbi" },
  { value: "Koko/Besse", label: "Koko/Besse", state: "Kebbi" },
  { value: "Maiyama", label: "Maiyama", state: "Kebbi" },
  { value: "Ngaski", label: "Ngaski", state: "Kebbi" },
  { value: "Sakaba", label: "Sakaba", state: "Kebbi" },
  { value: "Shanga", label: "Shanga", state: "Kebbi" },
  { value: "Suru", label: "Suru", state: "Kebbi" },
  { value: "Wasagu/Danko", label: "Wasagu/Danko", state: "Kebbi" },
  { value: "Yauri", label: "Yauri", state: "Kebbi" },
  { value: "Zuru", label: "Zuru", state: "Kebbi" },

  // KOGI
  { value: "Adavi", label: "Adavi", state: "Kogi" },
  { value: "Ajaokuta", label: "Ajaokuta", state: "Kogi" },
  { value: "Ankpa", label: "Ankpa", state: "Kogi" },
  { value: "Bassa", label: "Bassa", state: "Kogi" },
  { value: "Dekina", label: "Dekina", state: "Kogi" },
  { value: "Ibaji", label: "Ibaji", state: "Kogi" },
  { value: "Idah", label: "Idah", state: "Kogi" },
  { value: "Igalamela Odolu", label: "Igalamela Odolu", state: "Kogi" },
  { value: "Ijumu", label: "Ijumu", state: "Kogi" },
  { value: "Kabba/Bunu", label: "Kabba/Bunu", state: "Kogi" },
  { value: "Kogi", label: "Kogi", state: "Kogi" },
  { value: "Lokoja", label: "Lokoja", state: "Kogi" },
  { value: "Mopa Muro", label: "Mopa Muro", state: "Kogi" },
  { value: "Ofu", label: "Ofu", state: "Kogi" },
  { value: "Ogori/Magongo", label: "Ogori/Magongo", state: "Kogi" },
  { value: "Okehi", label: "Okehi", state: "Kogi" },
  { value: "Okene", label: "Okene", state: "Kogi" },
  { value: "Olamaboro", label: "Olamaboro", state: "Kogi" },
  { value: "Omala", label: "Omala", state: "Kogi" },
  { value: "Yagba East", label: "Yagba East", state: "Kogi" },
  { value: "Yagba West", label: "Yagba West", state: "Kogi" },

  // KWARA
  { value: "Asa", label: "Asa", state: "Kwara" },
  { value: "Baruten", label: "Baruten", state: "Kwara" },
  { value: "Edu", label: "Edu", state: "Kwara" },
  { value: "Ekiti", label: "Ekiti", state: "Kwara" },
  { value: "Ifelodun", label: "Ifelodun", state: "Kwara" },
  { value: "Ilorin East", label: "Ilorin East", state: "Kwara" },
  { value: "Ilorin South", label: "Ilorin South", state: "Kwara" },
  { value: "Ilorin West", label: "Ilorin West", state: "Kwara" },
  { value: "Irepodun", label: "Irepodun", state: "Kwara" },
  { value: "Isin", label: "Isin", state: "Kwara" },
  { value: "Kaiama", label: "Kaiama", state: "Kwara" },
  { value: "Moro", label: "Moro", state: "Kwara" },
  { value: "Offa", label: "Offa", state: "Kwara" },
  { value: "Oke Ero", label: "Oke Ero", state: "Kwara" },
  { value: "Oyun", label: "Oyun", state: "Kwara" },
  { value: "Pategi", label: "Pategi", state: "Kwara" },

  // LAGOS
  { value: "Agege", label: "Agege", state: "Lagos" },
  { value: "Ajeromi-Ifelodun", label: "Ajeromi-Ifelodun", state: "Lagos" },
  { value: "Alimosho", label: "Alimosho", state: "Lagos" },
  { value: "Amuwo-Odofin", label: "Amuwo-Odofin", state: "Lagos" },
  { value: "Apapa", label: "Apapa", state: "Lagos" },
  { value: "Badagry", label: "Badagry", state: "Lagos" },
  { value: "Epe", label: "Epe", state: "Lagos" },
  { value: "Eti-Osa", label: "Eti-Osa", state: "Lagos" },
  { value: "Ibeju-Lekki", label: "Ibeju-Lekki", state: "Lagos" },
  { value: "Ifako-Ijaiye", label: "Ifako-Ijaiye", state: "Lagos" },
  { value: "Ikeja", label: "Ikeja", state: "Lagos" },
  { value: "Ikorodu", label: "Ikorodu", state: "Lagos" },
  { value: "Kosofe", label: "Kosofe", state: "Lagos" },
  { value: "Lagos Island", label: "Lagos Island", state: "Lagos" },
  { value: "Lagos Mainland", label: "Lagos Mainland", state: "Lagos" },
  { value: "Mushin", label: "Mushin", state: "Lagos" },
  { value: "Ojo", label: "Ojo", state: "Lagos" },
  { value: "Oshodi-Isolo", label: "Oshodi-Isolo", state: "Lagos" },
  { value: "Shomolu", label: "Shomolu", state: "Lagos" },
  { value: "Surulere", label: "Surulere", state: "Lagos" },

  // NASARAWA
  { value: "Akwanga", label: "Akwanga", state: "Nasarawa" },
  { value: "Awe", label: "Awe", state: "Nasarawa" },
  { value: "Doma", label: "Doma", state: "Nasarawa" },
  { value: "Karu", label: "Karu", state: "Nasarawa" },
  { value: "Keana", label: "Keana", state: "Nasarawa" },
  { value: "Keffi", label: "Keffi", state: "Nasarawa" },
  { value: "Kokona", label: "Kokona", state: "Nasarawa" },
  { value: "Lafia", label: "Lafia", state: "Nasarawa" },
  { value: "Nasarawa", label: "Nasarawa", state: "Nasarawa" },
  { value: "Nasarawa Egon", label: "Nasarawa Egon", state: "Nasarawa" },
  { value: "Obi", label: "Obi", state: "Nasarawa" },
  { value: "Toto", label: "Toto", state: "Nasarawa" },
  { value: "Wamba", label: "Wamba", state: "Nasarawa" },

  // NIGER
  { value: "Agaie", label: "Agaie", state: "Niger" },
  { value: "Agwara", label: "Agwara", state: "Niger" },
  { value: "Bida", label: "Bida", state: "Niger" },
  { value: "Borgu", label: "Borgu", state: "Niger" },
  { value: "Bosso", label: "Bosso", state: "Niger" },
  { value: "Chanchaga", label: "Chanchaga", state: "Niger" },
  { value: "Edati", label: "Edati", state: "Niger" },
  { value: "Gbako", label: "Gbako", state: "Niger" },
  { value: "Gurara", label: "Gurara", state: "Niger" },
  { value: "Katcha", label: "Katcha", state: "Niger" },
  { value: "Kontagora", label: "Kontagora", state: "Niger" },
  { value: "Lapai", label: "Lapai", state: "Niger" },
  { value: "Lavun", label: "Lavun", state: "Niger" },
  { value: "Magama", label: "Magama", state: "Niger" },
  { value: "Mariga", label: "Mariga", state: "Niger" },
  { value: "Mashegu", label: "Mashegu", state: "Niger" },
  { value: "Mokwa", label: "Mokwa", state: "Niger" },
  { value: "Muya", label: "Muya", state: "Niger" },
  { value: "Paikoro", label: "Paikoro", state: "Niger" },
  { value: "Rafi", label: "Rafi", state: "Niger" },
  { value: "Rijau", label: "Rijau", state: "Niger" },
  { value: "Shiroro", label: "Shiroro", state: "Niger" },
  { value: "Suleja", label: "Suleja", state: "Niger" },
  { value: "Tafa", label: "Tafa", state: "Niger" },
  { value: "Wushishi", label: "Wushishi", state: "Niger" },

  // OGUN
  { value: "Abeokuta North", label: "Abeokuta North", state: "Ogun" },
  { value: "Abeokuta South", label: "Abeokuta South", state: "Ogun" },
  { value: "Ado-Odo/Ota", label: "Ado-Odo/Ota", state: "Ogun" },
  { value: "Egbado North", label: "Egbado North", state: "Ogun" },
  { value: "Egbado South", label: "Egbado South", state: "Ogun" },
  { value: "Ewekoro", label: "Ewekoro", state: "Ogun" },
  { value: "Ifo", label: "Ifo", state: "Ogun" },
  { value: "Ijebu East", label: "Ijebu East", state: "Ogun" },
  { value: "Ijebu North", label: "Ijebu North", state: "Ogun" },
  { value: "Ijebu North East", label: "Ijebu North East", state: "Ogun" },
  { value: "Ijebu Ode", label: "Ijebu Ode", state: "Ogun" },
  { value: "Ikenne", label: "Ikenne", state: "Ogun" },
  { value: "Imeko Afon", label: "Imeko Afon", state: "Ogun" },
  { value: "Ipokia", label: "Ipokia", state: "Ogun" },
  { value: "Obafemi Owode", label: "Obafemi Owode", state: "Ogun" },
  { value: "Odeda", label: "Odeda", state: "Ogun" },
  { value: "Odogbolu", label: "Odogbolu", state: "Ogun" },
  { value: "Ogun Waterside", label: "Ogun Waterside", state: "Ogun" },
  { value: "Remo North", label: "Remo North", state: "Ogun" },
  { value: "Sagamu", label: "Sagamu", state: "Ogun" },

  // ONDO
  { value: "Akoko North-East", label: "Akoko North-East", state: "Ondo" },
  { value: "Akoko North-West", label: "Akoko North-West", state: "Ondo" },
  { value: "Akoko South-East", label: "Akoko South-East", state: "Ondo" },
  { value: "Akoko South-West", label: "Akoko South-West", state: "Ondo" },
  { value: "Akure North", label: "Akure North", state: "Ondo" },
  { value: "Akure South", label: "Akure South", state: "Ondo" },
  { value: "Ese Odo", label: "Ese Odo", state: "Ondo" },
  { value: "Idanre", label: "Idanre", state: "Ondo" },
  { value: "Ifedore", label: "Ifedore", state: "Ondo" },
  { value: "Ilaje", label: "Ilaje", state: "Ondo" },
  { value: "Ile Oluji/Okeigbo", label: "Ile Oluji/Okeigbo", state: "Ondo" },
  { value: "Irele", label: "Irele", state: "Ondo" },
  { value: "Odigbo", label: "Odigbo", state: "Ondo" },
  { value: "Okitipupa", label: "Okitipupa", state: "Ondo" },
  { value: "Ondo East", label: "Ondo East", state: "Ondo" },
  { value: "Ondo West", label: "Ondo West", state: "Ondo" },
  { value: "Ose", label: "Ose", state: "Ondo" },
  { value: "Owo", label: "Owo", state: "Ondo" },

  // OSUN
  { value: "Atakunmosa East", label: "Atakunmosa East", state: "Osun" },
  { value: "Atakunmosa West", label: "Atakunmosa West", state: "Osun" },
  { value: "Aiyedaade", label: "Aiyedaade", state: "Osun" },
  { value: "Aiyedire", label: "Aiyedire", state: "Osun" },
  { value: "Boluwaduro", label: "Boluwaduro", state: "Osun" },
  { value: "Boripe", label: "Boripe", state: "Osun" },
  { value: "Ede North", label: "Ede North", state: "Osun" },
  { value: "Ede South", label: "Ede South", state: "Osun" },
  { value: "Egbedore", label: "Egbedore", state: "Osun" },
  { value: "Ejigbo", label: "Ejigbo", state: "Osun" },
  { value: "Ife Central", label: "Ife Central", state: "Osun" },
  { value: "Ife East", label: "Ife East", state: "Osun" },
  { value: "Ife North", label: "Ife North", state: "Osun" },
  { value: "Ife South", label: "Ife South", state: "Osun" },
  { value: "Ifedayo", label: "Ifedayo", state: "Osun" },
  { value: "Ifelodun", label: "Ifelodun", state: "Osun" },
  { value: "Ila", label: "Ila", state: "Osun" },
  { value: "Ilesa East", label: "Ilesa East", state: "Osun" },
  { value: "Ilesa West", label: "Ilesa West", state: "Osun" },
  { value: "Irepodun", label: "Irepodun", state: "Osun" },
  { value: "Irewole", label: "Irewole", state: "Osun" },
  { value: "Isokan", label: "Isokan", state: "Osun" },
  { value: "Iwo", label: "Iwo", state: "Osun" },
  { value: "Obokun", label: "Obokun", state: "Osun" },
  { value: "Odo Otin", label: "Odo Otin", state: "Osun" },
  { value: "Ola Oluwa", label: "Ola Oluwa", state: "Osun" },
  { value: "Olorunda", label: "Olorunda", state: "Osun" },
  { value: "Oriade", label: "Oriade", state: "Osun" },
  { value: "Orolu", label: "Orolu", state: "Osun" },
  { value: "Osogbo", label: "Osogbo", state: "Osun" },

  // OYO
  { value: "Afijio", label: "Afijio", state: "Oyo" },
  { value: "Akinyele", label: "Akinyele", state: "Oyo" },
  { value: "Atiba", label: "Atiba", state: "Oyo" },
  { value: "Atisbo", label: "Atisbo", state: "Oyo" },
  { value: "Egbeda", label: "Egbeda", state: "Oyo" },
  { value: "Ibadan North", label: "Ibadan North", state: "Oyo" },
  { value: "Ibadan North-East", label: "Ibadan North-East", state: "Oyo" },
  { value: "Ibadan North-West", label: "Ibadan North-West", state: "Oyo" },
  { value: "Ibadan South-East", label: "Ibadan South-East", state: "Oyo" },
  { value: "Ibadan South-West", label: "Ibadan South-West", state: "Oyo" },
  { value: "Ibarapa Central", label: "Ibarapa Central", state: "Oyo" },
  { value: "Ibarapa East", label: "Ibarapa East", state: "Oyo" },
  { value: "Ibarapa North", label: "Ibarapa North", state: "Oyo" },
  { value: "Ido", label: "Ido", state: "Oyo" },
  { value: "Irepo", label: "Irepo", state: "Oyo" },
  { value: "Iseyin", label: "Iseyin", state: "Oyo" },
  { value: "Itesiwaju", label: "Itesiwaju", state: "Oyo" },
  { value: "Iwajowa", label: "Iwajowa", state: "Oyo" },
  { value: "Kajola", label: "Kajola", state: "Oyo" },
  { value: "Lagelu", label: "Lagelu", state: "Oyo" },
  { value: "Ogbomosho North", label: "Ogbomosho North", state: "Oyo" },
  { value: "Ogbomosho South", label: "Ogbomosho South", state: "Oyo" },
  { value: "Ogo Oluwa", label: "Ogo Oluwa", state: "Oyo" },
  { value: "Olorunsogo", label: "Olorunsogo", state: "Oyo" },
  { value: "Oluyole", label: "Oluyole", state: "Oyo" },
  { value: "Ona Ara", label: "Ona Ara", state: "Oyo" },
  { value: "Orelope", label: "Orelope", state: "Oyo" },
  { value: "Ori Ire", label: "Ori Ire", state: "Oyo" },
  { value: "Oyo East", label: "Oyo East", state: "Oyo" },
  { value: "Oyo West", label: "Oyo West", state: "Oyo" },
  { value: "Saki East", label: "Saki East", state: "Oyo" },
  { value: "Saki West", label: "Saki West", state: "Oyo" },
  { value: "Surulere", label: "Surulere", state: "Oyo" },

  // PLATEAU
  { value: "Barkin Ladi", label: "Barkin Ladi", state: "Plateau" },
  { value: "Bassa", label: "Bassa", state: "Plateau" },
  { value: "Bokkos", label: "Bokkos", state: "Plateau" },
  { value: "Jos East", label: "Jos East", state: "Plateau" },
  { value: "Jos North", label: "Jos North", state: "Plateau" },
  { value: "Jos South", label: "Jos South", state: "Plateau" },
  { value: "Kanam", label: "Kanam", state: "Plateau" },
  { value: "Kanke", label: "Kanke", state: "Plateau" },
  { value: "Langtang North", label: "Langtang North", state: "Plateau" },
  { value: "Langtang South", label: "Langtang South", state: "Plateau" },
  { value: "Mangu", label: "Mangu", state: "Plateau" },
  { value: "Mikang", label: "Mikang", state: "Plateau" },
  { value: "Pankshin", label: "Pankshin", state: "Plateau" },
  { value: "Qua'an Pan", label: "Qua'an Pan", state: "Plateau" },
  { value: "Riyom", label: "Riyom", state: "Plateau" },
  { value: "Shendam", label: "Shendam", state: "Plateau" },
  { value: "Wase", label: "Wase", state: "Plateau" },

  // RIVERS
  { value: "Abua/Odual", label: "Abua/Odual", state: "Rivers" },
  { value: "Ahoada East", label: "Ahoada East", state: "Rivers" },
  { value: "Ahoada West", label: "Ahoada West", state: "Rivers" },
  { value: "Akuku-Toru", label: "Akuku-Toru", state: "Rivers" },
  { value: "Andoni", label: "Andoni", state: "Rivers" },
  { value: "Asari-Toru", label: "Asari-Toru", state: "Rivers" },
  { value: "Bonny", label: "Bonny", state: "Rivers" },
  { value: "Degema", label: "Degema", state: "Rivers" },
  { value: "Eleme", label: "Eleme", state: "Rivers" },
  { value: "Emuoha", label: "Emuoha", state: "Rivers" },
  { value: "Etche", label: "Etche", state: "Rivers" },
  { value: "Gokana", label: "Gokana", state: "Rivers" },
  { value: "Ikwerre", label: "Ikwerre", state: "Rivers" },
  { value: "Khana", label: "Khana", state: "Rivers" },
  { value: "Obio/Akpor", label: "Obio/Akpor", state: "Rivers" },
  { value: "Ogba/Egbema/Ndoni", label: "Ogba/Egbema/Ndoni", state: "Rivers" },
  { value: "Ogu/Bolo", label: "Ogu/Bolo", state: "Rivers" },
  { value: "Okrika", label: "Okrika", state: "Rivers" },
  { value: "Omuma", label: "Omuma", state: "Rivers" },
  { value: "Opobo/Nkoro", label: "Opobo/Nkoro", state: "Rivers" },
  { value: "Oyigbo", label: "Oyigbo", state: "Rivers" },
  { value: "Port Harcourt", label: "Port Harcourt", state: "Rivers" },
  { value: "Tai", label: "Tai", state: "Rivers" },

  // SOKOTO
  { value: "Binji", label: "Binji", state: "Sokoto" },
  { value: "Bodinga", label: "Bodinga", state: "Sokoto" },
  { value: "Dange Shuni", label: "Dange Shuni", state: "Sokoto" },
  { value: "Gada", label: "Gada", state: "Sokoto" },
  { value: "Goronyo", label: "Goronyo", state: "Sokoto" },
  { value: "Gudu", label: "Gudu", state: "Sokoto" },
  { value: "Gwadabawa", label: "Gwadabawa", state: "Sokoto" },
  { value: "Illela", label: "Illela", state: "Sokoto" },
  { value: "Isa", label: "Isa", state: "Sokoto" },
  { value: "Kebbe", label: "Kebbe", state: "Sokoto" },
  { value: "Kware", label: "Kware", state: "Sokoto" },
  { value: "Rabah", label: "Rabah", state: "Sokoto" },
  { value: "Sabon Birni", label: "Sabon Birni", state: "Sokoto" },
  { value: "Shagari", label: "Shagari", state: "Sokoto" },
  { value: "Silame", label: "Silame", state: "Sokoto" },
  { value: "Sokoto North", label: "Sokoto North", state: "Sokoto" },
  { value: "Sokoto South", label: "Sokoto South", state: "Sokoto" },
  { value: "Tambuwal", label: "Tambuwal", state: "Sokoto" },
  { value: "Tangaza", label: "Tangaza", state: "Sokoto" },
  { value: "Tureta", label: "Tureta", state: "Sokoto" },
  { value: "Wamako", label: "Wamako", state: "Sokoto" },
  { value: "Wurno", label: "Wurno", state: "Sokoto" },
  { value: "Yabo", label: "Yabo", state: "Sokoto" },

  // TARABA
  { value: "Ardo Kola", label: "Ardo Kola", state: "Taraba" },
  { value: "Bali", label: "Bali", state: "Taraba" },
  { value: "Donga", label: "Donga", state: "Taraba" },
  { value: "Gashaka", label: "Gashaka", state: "Taraba" },
  { value: "Gassol", label: "Gassol", state: "Taraba" },
  { value: "Ibi", label: "Ibi", state: "Taraba" },
  { value: "Jalingo", label: "Jalingo", state: "Taraba" },
  { value: "Karim Lamido", label: "Karim Lamido", state: "Taraba" },
  { value: "Kumi", label: "Kumi", state: "Taraba" },
  { value: "Lau", label: "Lau", state: "Taraba" },
  { value: "Sardauna", label: "Sardauna", state: "Taraba" },
  { value: "Takum", label: "Takum", state: "Taraba" },
  { value: "Ussa", label: "Ussa", state: "Taraba" },
  { value: "Wukari", label: "Wukari", state: "Taraba" },
  { value: "Yorro", label: "Yorro", state: "Taraba" },
  { value: "Zing", label: "Zing", state: "Taraba" },

  // YOBE
  { value: "Bade", label: "Bade", state: "Yobe" },
  { value: "Bursari", label: "Bursari", state: "Yobe" },
  { value: "Damaturu", label: "Damaturu", state: "Yobe" },
  { value: "Fika", label: "Fika", state: "Yobe" },
  { value: "Fune", label: "Fune", state: "Yobe" },
  { value: "Geidam", label: "Geidam", state: "Yobe" },
  { value: "Gujba", label: "Gujba", state: "Yobe" },
  { value: "Gulani", label: "Gulani", state: "Yobe" },
  { value: "Jakusko", label: "Jakusko", state: "Yobe" },
  { value: "Karasuwa", label: "Karasuwa", state: "Yobe" },
  { value: "Machina", label: "Machina", state: "Yobe" },
  { value: "Nangere", label: "Nangere", state: "Yobe" },
  { value: "Nguru", label: "Nguru", state: "Yobe" },
  { value: "Potiskum", label: "Potiskum", state: "Yobe" },
  { value: "Tarmuwa", label: "Tarmuwa", state: "Yobe" },
  { value: "Yunusari", label: "Yunusari", state: "Yobe" },
  { value: "Yusufari", label: "Yusufari", state: "Yobe" },

  // ZAMFARA
  { value: "Anka", label: "Anka", state: "Zamfara" },
  { value: "Bakura", label: "Bakura", state: "Zamfara" },
  { value: "Birnin Magaji/Kiyaw", label: "Birnin Magaji/Kiyaw", state: "Zamfara" },
  { value: "Bukkuyum", label: "Bukkuyum", state: "Zamfara" },
  { value: "Bungudu", label: "Bungudu", state: "Zamfara" },
  { value: "Gummi", label: "Gummi", state: "Zamfara" },
  { value: "Gusau", label: "Gusau", state: "Zamfara" },
  { value: "Kaura Namoda", label: "Kaura Namoda", state: "Zamfara" },
  { value: "Maradun", label: "Maradun", state: "Zamfara" },
  { value: "Maru", label: "Maru", state: "Zamfara" },
  { value: "Shinkafi", label: "Shinkafi", state: "Zamfara" },
  { value: "Talata Mafara", label: "Talata Mafara", state: "Zamfara" },
  { value: "Tsafe", label: "Tsafe", state: "Zamfara" },
  { value: "Zurmi", label: "Zurmi", state: "Zamfara" }
]
// export const LocalGovernmentAreaInfo = [
//   { value: "Bende", label: "Bende", state: "Abia" },
//   { value: "Ikwuano", label: "Ikwuano", state: "Abia" },
//   { value: "Isiala Ngwa North", label: "Isiala Ngwa North", state: "Abia" },
//   { value: "Isiala Ngwa South", label: "Isiala Ngwa South", state: "Abia" },
//   { value: "Isuikwuato", label: "Isuikwuato", state: "Abia" },
//   { value: "Obi Ngwa", label: "Obi Ngwa", state: "Abia" },
//   { value: "Ohafia", label: "Ohafia", state: "Abia" },
//   { value: "Osisioma", label: "Osisioma", state: "Abia" },
//   { value: "Ugwunagbo", label: "Ugwunagbo", state: "Abia" },
//   { value: "Ukwa East", label: "Ukwa East", state: "Abia" },
//   { value: "Ukwa West", label: "Ukwa West", state: "Abia" },
//   { value: "Umuahia North", label: "Umuahia North", state: "Abia" },
//   { value: "Umuahia South", label: "Umuahia South", state: "Abia" },
//   { value: "Umu Nneochi", label: "Umu Nneochi", state: "Abia" },

//   { value: "Demsa", label: "Demsa", state: "Adamawa" },
//   { value: "Fufure", label: "Fufure", state: "Adamawa" },
//   { value: "Ganye", label: "Ganye", state: "Adamawa" },
//   { value: "Guyuk", label: "Guyuk", state: "Adamawa" },
//   { value: "Girei", label: "Girei", state: "Adamawa" },
//   { value: "Gombi", label: "Gombi", state: "Adamawa" },
//   { value: "Hong", label: "Hong", state: "Adamawa" },
//   { value: "Jada", label: "Jada", state: "Adamawa" },
//   { value: "Lamurde", label: "Lamurde", state: "Adamawa" },
//   { value: "Madagali", label: "Madagali", state: "Adamawa" },
//   { value: "Maiha", label: "Maiha", state: "Adamawa" },
//   { value: "Mayo Belwa", label: "Mayo Belwa", state: "Adamawa" },
//   { value: "Michika", label: "Michika", state: "Adamawa" },
//   { value: "Mubi North", label: "Mubi North", state: "Adamawa" },
//   { value: "Mubi South", label: "Mubi South", state: "Adamawa" },
//   { value: "Numan", label: "Numan", state: "Adamawa" },
//   { value: "Shelleng", label: "Shelleng", state: "Adamawa" },
//   { value: "Song", label: "Song", state: "Adamawa" },
//   { value: "Toungo", label: "Toungo", state: "Adamawa" },
//   { value: "Yola North", label: "Yola North", state: "Adamawa" },
//   { value: "Yola South", label: "Yola South", state: "Adamawa" },

//   // Akwa Ibom State
//   { value: "Abak", label: "Abak", state: "Akwa Ibom" },
//   { value: "Eastern Obolo", label: "Eastern Obolo", state: "Akwa Ibom" },
//   { value: "Eket", label: "Eket", state: "Akwa Ibom" },
//   { value: "Esit Eket", label: "Esit Eket", state: "Akwa Ibom" },
//   { value: "Essien Udim", label: "Essien Udim", state: "Akwa Ibom" },
//   { value: "Etim Ekpo", label: "Etim Ekpo", state: "Akwa Ibom" },
//   { value: "Etinan", label: "Etinan", state: "Akwa Ibom" },
//   { value: "Ibeno", label: "Ibeno", state: "Akwa Ibom" },
//   { value: "Ibesikpo Asutan", label: "Ibesikpo Asutan", state: "Akwa Ibom" },
//   { value: "Ibiono-Ibom", label: "Ibiono-Ibom", state: "Akwa Ibom" },
//   { value: "Ika", label: "Ika", state: "Akwa Ibom" },
//   { value: "Ikono", label: "Ikono", state: "Akwa Ibom" },
//   { value: "Abasi", label: "Abasi", state: "Akwa Ibom" },
//   { value: "Ikot Ekpene", label: "Ikot Ekpene", state: "Akwa Ibom" },
//   { value: "Ini", label: "Ini", state: "Akwa Ibom" },
//   { value: "Itu", label: "Itu", state: "Akwa Ibom" },
//   { value: "Mbo", label: "Mbo", state: "Akwa Ibom" },
//   { value: "Mkpat-Enin", label: "Mkpat-Enin", state: "Akwa Ibom" },
//   { value: "Nsit-Atai", label: "Nsit-Atai", state: "Akwa Ibom" },
//   { value: "Nsit-Ibom", label: "Nsit-Ibom", state: "Akwa Ibom" },
//   { value: "Nsit-Ubium", label: "Nsit-Ubium", state: "Akwa Ibom" },
//   { value: "Obot Akara", label: "Obot Akara", state: "Akwa Ibom" },
//   { value: "Okobo", label: "Okobo", state: "Akwa Ibom" },
//   { value: "Onna", label: "Onna", state: "Akwa Ibom" },
//   { value: "Oron", label: "Oron", state: "Akwa Ibom" },
//   { value: "Oruk Anam", label: "Oruk Anam", state: "Akwa Ibom" },
//   { value: "Udung-Uko", label: "Udung-Uko", state: "Akwa Ibom" },
//   { value: "Ukanafun", label: "Ukanafun", state: "Akwa Ibom" },
//   { value: "Uruan", label: "Uruan", state: "Akwa Ibom" },
//   {
//     value: "Urue-Offong/Oruko",
//     label: "Urue-Offong/Oruko",
//     state: "Akwa Ibom",
//   },
//   { value: "Uyo", label: "Uyo", state: "Akwa Ibom" },

//   // Anambra State
//   { value: "Aguata", label: "Aguata", state: "Anambra" },
//   { value: "Anambra East", label: "Anambra East", state: "Anambra" },
//   { value: "Anambra West", label: "Anambra West", state: "Anambra" },
//   { value: "Anaocha", label: "Anaocha", state: "Anambra" },
//   { value: "Awka North", label: "Awka North", state: "Anambra" },
//   { value: "Awka South", label: "Awka South", state: "Anambra" },
//   { value: "Ayamelum", label: "Ayamelum", state: "Anambra" },
//   { value: "Dunukofia", label: "Dunukofia", state: "Anambra" },
//   { value: "Ekwusigo", label: "Ekwusigo", state: "Anambra" },
//   { value: "Idemili North", label: "Idemili North", state: "Anambra" },
//   { value: "Idemili South", label: "Idemili South", state: "Anambra" },
//   { value: "Ihiala", label: "Ihiala", state: "Anambra" },
//   { value: "Njikoka", label: "Njikoka", state: "Anambra" },
//   { value: "Nnewi North", label: "Nnewi North", state: "Anambra" },
//   { value: "Nnewi South", label: "Nnewi South", state: "Anambra" },
//   { value: "Ogbaru", label: "Ogbaru", state: "Anambra" },
//   { value: "Onitsha North", label: "Onitsha North", state: "Anambra" },
//   { value: "Onitsha South", label: "Onitsha South", state: "Anambra" },
//   { value: "Orumba North", label: "Orumba North", state: "Anambra" },
//   { value: "Orumba South", label: "Orumba South", state: "Anambra" },
//   { value: "Oyi", label: "Oyi", state: "Anambra" },

//   // Bauchi State
//   { value: "Alkaleri", label: "Alkaleri", state: "Bauchi" },
//   { value: "Bauchi", label: "Bauchi", state: "Bauchi" },
//   { value: "Bogoro", label: "Bogoro", state: "Bauchi" },
//   { value: "Damban", label: "Damban", state: "Bauchi" },
//   { value: "Darazo", label: "Darazo", state: "Bauchi" },
//   { value: "Dass", label: "Dass", state: "Bauchi" },
//   { value: "Gamawa", label: "Gamawa", state: "Bauchi" },
//   { value: "Ganjuwa", label: "Ganjuwa", state: "Bauchi" },
//   { value: "Giade", label: "Giade", state: "Bauchi" },
//   { value: "Itas/Gadau", label: "Itas/Gadau", state: "Bauchi" },
//   { value: "Jama'are", label: "Jama'are", state: "Bauchi" },
//   { value: "Katagum", label: "Katagum", state: "Bauchi" },
//   { value: "Kirfi", label: "Kirfi", state: "Bauchi" },
//   { value: "Misau", label: "Misau", state: "Bauchi" },
//   { value: "Ningi", label: "Ningi", state: "Bauchi" },
//   { value: "Shira", label: "Shira", state: "Bauchi" },
//   { value: "Tafawa Balewa", label: "Tafawa Balewa", state: "Bauchi" },
//   { value: "Toro", label: "Toro", state: "Bauchi" },
//   { value: "Warji", label: "Warji", state: "Bauchi" },
//   { value: "Zaki", label: "Zaki", state: "Bauchi" },

//   // Bayelsa State
//   { value: "Brass", label: "Brass", state: "Bayelsa" },
//   { value: "Ekeremor", label: "Ekeremor", state: "Bayelsa" },
//   { value: "Kolokuma/Opokuma", label: "Kolokuma/Opokuma", state: "Bayelsa" },
//   { value: "Nembe", label: "Nembe", state: "Bayelsa" },
//   { value: "Ogbia", label: "Ogbia", state: "Bayelsa" },
//   { value: "Sagbama", label: "Sagbama", state: "Bayelsa" },
//   { value: "Southern Ijaw", label: "Southern Ijaw", state: "Bayelsa" },
//   { value: "Yenagoa", label: "Yenagoa", state: "Bayelsa" },

//   // Benue State
//   { value: "Ado", label: "Ado", state: "Benue" },
//   { value: "Agatu", label: "Agatu", state: "Benue" },
//   { value: "Apa", label: "Apa", state: "Benue" },
//   { value: "Buruku", label: "Buruku", state: "Benue" },
//   { value: "Gboko", label: "Gboko", state: "Benue" },
//   { value: "Guma", label: "Guma", state: "Benue" },
//   { value: "Gwer East", label: "Gwer East", state: "Benue" },
//   { value: "Gwer West", label: "Gwer West", state: "Benue" },
//   { value: "Katsina-Ala", label: "Katsina-Ala", state: "Benue" },
//   { value: "Konshisha", label: "Konshisha", state: "Benue" },
//   { value: "Kwande", label: "Kwande", state: "Benue" },
//   { value: "Logo", label: "Logo", state: "Benue" },
//   { value: "Makurdi", label: "Makurdi", state: "Benue" },
//   { value: "Obi", label: "Obi", state: "Benue" },
//   { value: "Ogbadibo", label: "Ogbadibo", state: "Benue" },
//   { value: "Ohimini", label: "Ohimini", state: "Benue" },
//   { value: "Oju", label: "Oju", state: "Benue" },
//   { value: "Okpokwu", label: "Okpokwu", state: "Benue" },
//   { value: "Oturkpo", label: "Oturkpo", state: "Benue" },
//   { value: "Tarka", label: "Tarka", state: "Benue" },
//   { value: "Ukum", label: "Ukum", state: "Benue" },
//   { value: "Ushongo", label: "Ushongo", state: "Benue" },
//   { value: "Vandeikya", label: "Vandeikya", state: "Benue" },

//   // Borno State
//   { value: "Abadam", label: "Abadam", state: "Borno" },
//   { value: "Askira/Uba", label: "Askira/Uba", state: "Borno" },
//   { value: "Bama", label: "Bama", state: "Borno" },
//   { value: "Bayo", label: "Bayo", state: "Borno" },
//   { value: "Biu", label: "Biu", state: "Borno" },
//   { value: "Chibok", label: "Chibok", state: "Borno" },
//   { value: "Damboa", label: "Damboa", state: "Borno" },
//   { value: "Dikwa", label: "Dikwa", state: "Borno" },
//   { value: "Gubio", label: "Gubio", state: "Borno" },
//   { value: "Guzamala", label: "Guzamala", state: "Borno" },
//   { value: "Gwoza", label: "Gwoza", state: "Borno" },
//   { value: "Hawul", label: "Hawul", state: "Borno" },
//   { value: "Jere", label: "Jere", state: "Borno" },
//   { value: "Kaga", label: "Kaga", state: "Borno" },
//   { value: "Kala/Balge", label: "Kala/Balge", state: "Borno" },
//   { value: "Konduga", label: "Konduga", state: "Borno" },
//   { value: "Kukawa", label: "Kukawa", state: "Borno" },
//   { value: "Kwaya Kusar", label: "Kwaya Kusar", state: "Borno" },
//   { value: "Mafa", label: "Mafa", state: "Borno" },
//   { value: "Magumeri", label: "Magumeri", state: "Borno" },
//   { value: "Maiduguri", label: "Maiduguri", state: "Borno" },
//   { value: "Marte", label: "Marte", state: "Borno" },
//   { value: "Mobbar", label: "Mobbar", state: "Borno" },
//   { value: "Monguno", label: "Monguno", state: "Borno" },
//   { value: "Ngala", label: "Ngala", state: "Borno" },
//   { value: "Nganzai", label: "Nganzai", state: "Borno" },
//   { value: "Shani", label: "Shani", state: "Borno" },

//   // Cross River State
//   { value: "Abi", label: "Abi", state: "Cross River" },
//   { value: "Akamkpa", label: "Akamkpa", state: "Cross River" },
//   { value: "Akpabuyo", label: "Akpabuyo", state: "Cross River" },
//   { value: "Bakassi", label: "Bakassi", state: "Cross River" },
//   { value: "Bekwarra", label: "Bekwarra", state: "Cross River" },
//   { value: "Biase", label: "Biase", state: "Cross River" },
//   { value: "Boki", label: "Boki", state: "Cross River" },
//   {
//     value: "Calabar Municipality",
//     label: "Calabar Municipality",
//     state: "Cross River",
//   },
//   { value: "Calabar South", label: "Calabar South", state: "Cross River" },
//   { value: "Etung", label: "Etung", state: "Cross River" },
//   { value: "Ikom", label: "Ikom", state: "Cross River" },
//   { value: "Obanliku", label: "Obanliku", state: "Cross River" },
//   { value: "Obubra", label: "Obubra", state: "Cross River" },
//   { value: "Obudu", label: "Obudu", state: "Cross River" },
//   { value: "Odukpani", label: "Odukpani", state: "Cross River" },
//   { value: "Ogoja", label: "Ogoja", state: "Cross River" },
//   { value: "Yakurr", label: "Yakurr", state: "Cross River" },
//   { value: "Yala", label: "Yala", state: "Cross River" },

//   // Delta State
//   { value: "Aniocha North", label: "Aniocha North", state: "Delta" },
//   { value: "Aniocha South", label: "Aniocha South", state: "Delta" },
//   { value: "Bomadi", label: "Bomadi", state: "Delta" },
//   { value: "Burutu", label: "Burutu", state: "Delta" },
//   { value: "Ethiope East", label: "Ethiope East", state: "Delta" },
//   { value: "Ethiope West", label: "Ethiope West", state: "Delta" },
//   { value: "Ika North East", label: "Ika North East", state: "Delta" },
//   { value: "Ika South", label: "Ika South", state: "Delta" },
//   { value: "Isoko North", label: "Isoko North", state: "Delta" },
//   { value: "Isoko South", label: "Isoko South", state: "Delta" },
//   { value: "Ndokwa East", label: "Ndokwa East", state: "Delta" },
//   { value: "Ndokwa West", label: "Ndokwa West", state: "Delta" },
//   { value: "Okpe", label: "Okpe", state: "Delta" },
//   { value: "Oshimili North", label: "Oshimili North", state: "Delta" },
//   { value: "Oshimili South", label: "Oshimili South", state: "Delta" },
//   { value: "Patani", label: "Patani", state: "Delta" },
//   { value: "Sapele", label: "Sapele", state: "Delta" },
//   { value: "Udu", label: "Udu", state: "Delta" },
//   { value: "Ughelli North", label: "Ughelli North", state: "Delta" },
//   { value: "Ughelli South", label: "Ughelli South", state: "Delta" },
//   { value: "Ukwuani", label: "Ukwuani", state: "Delta" },
//   { value: "Uvwie", label: "Uvwie", state: "Delta" },
//   { value: "Warri North", label: "Warri North", state: "Delta" },
//   { value: "Warri South", label: "Warri South", state: "Delta" },
//   { value: "Warri South West", label: "Warri South West", state: "Delta" },

//   // Ebonyi State
//   { value: "Abakaliki", label: "Abakaliki", state: "Ebonyi" },
//   { value: "Afikpo", label: "Afikpo", state: "Ebonyi" },
//   { value: "Edda", label: "Edda", state: "Ebonyi" },
//   { value: "Ebonyi", label: "Ebonyi", state: "Ebonyi" },
//   { value: "Ezza North", label: "Ezza North", state: "Ebonyi" },
//   { value: "Ezza South", label: "Ezza South", state: "Ebonyi" },
//   { value: "Ikwo", label: "Ikwo", state: "Ebonyi" },
//   { value: "Ishielu", label: "Ishielu", state: "Ebonyi" },
//   { value: "Ivo", label: "Ivo", state: "Ebonyi" },
//   { value: "Izzi", label: "Izzi", state: "Ebonyi" },
//   { value: "Ohaozara", label: "Ohaozara", state: "Ebonyi" },
//   { value: "Ohaukwu", label: "Ohaukwu", state: "Ebonyi" },
//   { value: "Onicha", label: "Onicha", state: "Ebonyi" },

//   // Edo State
//   { value: "Akoko-Edo", label: "Akoko-Edo", state: "Edo" },
//   { value: "Egor", label: "Egor", state: "Edo" },
//   { value: "Esan Central", label: "Esan Central", state: "Edo" },
//   { value: "Esan North-East", label: "Esan North-East", state: "Edo" },
//   { value: "Esan South-East", label: "Esan South-East", state: "Edo" },
//   { value: "Esan West", label: "Esan West", state: "Edo" },
//   { value: "Etsako Central", label: "Etsako Central", state: "Edo" },
//   { value: "Etsako East", label: "Etsako East", state: "Edo" },
//   { value: "Etsako West", label: "Etsako West", state: "Edo" },
//   { value: "Igueben", label: "Igueben", state: "Edo" },
//   { value: "Ikpoba Okha", label: "Ikpoba Okha", state: "Edo" },
//   { value: "Orhionmwon", label: "Orhionmwon", state: "Edo" },
//   { value: "Oredo", label: "Oredo", state: "Edo" },
//   { value: "Ovia North-East", label: "Ovia North-East", state: "Edo" },
//   { value: "Ovia South-West", label: "Ovia South-West", state: "Edo" },
//   { value: "Owan East", label: "Owan East", state: "Edo" },
//   { value: "Owan West", label: "Owan West", state: "Edo" },
//   { value: "Uhunmwonde", label: "Uhunmwonde", state: "Edo" },

//   // Ekiti State
//   { value: "Ado Ekiti", label: "Ado Ekiti", state: "Ekiti" },
//   { value: "Efon", label: "Efon", state: "Ekiti" },
//   { value: "Ekiti East", label: "Ekiti East", state: "Ekiti" },
//   { value: "Ekiti South-West", label: "Ekiti South-West", state: "Ekiti" },
//   { value: "Ekiti West", label: "Ekiti West", state: "Ekiti" },
//   { value: "Emure", label: "Emure", state: "Ekiti" },
//   { value: "Gbonyin", label: "Gbonyin", state: "Ekiti" },
//   { value: "Ido Osi", label: "Ido Osi", state: "Ekiti" },
//   { value: "Ijero", label: "Ijero", state: "Ekiti" },
//   { value: "Ikere", label: "Ikere", state: "Ekiti" },
//   { value: "Ikole", label: "Ikole", state: "Ekiti" },
//   { value: "Ilejemeje", label: "Ilejemeje", state: "Ekiti" },
//   { value: "Irepodun/Ifelodun", label: "Irepodun/Ifelodun", state: "Ekiti" },
//   { value: "Ise/Orun", label: "Ise/Orun", state: "Ekiti" },
//   { value: "Moba", label: "Moba", state: "Ekiti" },
//   { value: "Oye", label: "Oye", state: "Ekiti" },

//   // Enugu State
//   { value: "Aninri", label: "Aninri", state: "Enugu" },
//   { value: "Awgu", label: "Awgu", state: "Enugu" },
//   { value: "Enugu East", label: "Enugu East", state: "Enugu" },
//   { value: "Enugu North", label: "Enugu North", state: "Enugu" },
//   { value: "Enugu South", label: "Enugu South", state: "Enugu" },
//   { value: "Ezeagu", label: "Ezeagu", state: "Enugu" },
//   { value: "Igbo Etiti", label: "Igbo Etiti", state: "Enugu" },
//   { value: "Igbo Eze North", label: "Igbo Eze North", state: "Enugu" },
//   { value: "Igbo Eze South", label: "Igbo Eze South", state: "Enugu" },
//   { value: "Isi Uzo", label: "Isi Uzo", state: "Enugu" },
//   { value: "Nkanu East", label: "Nkanu East", state: "Enugu" },
//   { value: "Nkanu West", label: "Nkanu West", state: "Enugu" },
//   { value: "Nsukka", label: "Nsukka", state: "Enugu" },
//   { value: "Oji River", label: "Oji River", state: "Enugu" },
//   { value: "Udenu", label: "Udenu", state: "Enugu" },
//   { value: "Udi", label: "Udi", state: "Enugu" },
//   { value: "Uzo-Uwani", label: "Uzo-Uwani", state: "Enugu" },

//   // Gombe State
//   { value: "Akko", label: "Akko", state: "Gombe" },
//   { value: "Balanga", label: "Balanga", state: "Gombe" },
//   { value: "Billiri", label: "Billiri", state: "Gombe" },
//   { value: "Dukku", label: "Dukku", state: "Gombe" },
//   { value: "Funakaye", label: "Funakaye", state: "Gombe" },
//   { value: "Gombe", label: "Gombe", state: "Gombe" },
//   { value: "Kaltungo", label: "Kaltungo", state: "Gombe" },
//   { value: "Kwami", label: "Kwami", state: "Gombe" },
//   { value: "Nafada", label: "Nafada", state: "Gombe" },
//   { value: "Shongom", label: "Shongom", state: "Gombe" },
//   { value: "Yamaltu/Deba", label: "Yamaltu/Deba", state: "Gombe" },

//   // Imo State
//   { value: "Aboh Mbaise", label: "Aboh Mbaise", state: "Imo" },
//   { value: "Ahiazu Mbaise", label: "Ahiazu Mbaise", state: "Imo" },
//   { value: "Ehime Mbano", label: "Ehime Mbano", state: "Imo" },
//   { value: "Ezinihitte", label: "Ezinihitte", state: "Imo" },
//   { value: "Ideato North", label: "Ideato North", state: "Imo" },
//   { value: "Ideato South", label: "Ideato South", state: "Imo" },
//   { value: "Ihitte/Uboma", label: "Ihitte/Uboma", state: "Imo" },
//   { value: "Ikeduru", label: "Ikeduru", state: "Imo" },
//   { value: "Isiala Mbano", label: "Isiala Mbano", state: "Imo" },
//   { value: "Isu", label: "Isu", state: "Imo" },
//   { value: "Mbaitoli", label: "Mbaitoli", state: "Imo" },
//   { value: "Ngor Okpala", label: "Ngor Okpala", state: "Imo" },
//   { value: "Njaba", label: "Njaba", state: "Imo" },
//   { value: "Nkwerre", label: "Nkwerre", state: "Imo" },
//   { value: "Nwangele", label: "Nwangele", state: "Imo" },
//   { value: "Obowo", label: "Obowo", state: "Imo" },
//   { value: "Oguta", label: "Oguta", state: "Imo" },
//   { value: "Ohaji/Egbema", label: "Ohaji/Egbema", state: "Imo" },
//   { value: "Okigwe", label: "Okigwe", state: "Imo" },
//   { value: "Orlu", label: "Orlu", state: "Imo" },
//   { value: "Orsu", label: "Orsu", state: "Imo" },
//   { value: "Oru East", label: "Oru East", state: "Imo" },
//   { value: "Oru West", label: "Oru West", state: "Imo" },
//   { value: "Owerri Municipal", label: "Owerri Municipal", state: "Imo" },
//   { value: "Owerri North", label: "Owerri North", state: "Imo" },
//   { value: "Owerri West", label: "Owerri West", state: "Imo" },
//   { value: "Onuimo", label: "Onuimo", state: "Imo" },

//   // Jigawa State
//   { value: "Auyo", label: "Auyo", state: "Jigawa" },
//   { value: "Babura", label: "Babura", state: "Jigawa" },
//   { value: "Birniwa", label: "Birniwa", state: "Jigawa" },
//   { value: "Birnin Kudu", label: "Birnin Kudu", state: "Jigawa" },
//   { value: "Buji", label: "Buji", state: "Jigawa" },
//   { value: "Dutse", label: "Dutse", state: "Jigawa" },
//   { value: "Gagarawa", label: "Gagarawa", state: "Jigawa" },
//   { value: "Garki", label: "Garki", state: "Jigawa" },
//   { value: "Gumel", label: "Gumel", state: "Jigawa" },
//   { value: "Guri", label: "Guri", state: "Jigawa" },
//   { value: "Gwaram", label: "Gwaram", state: "Jigawa" },
//   { value: "Gwiwa", label: "Gwiwa", state: "Jigawa" },
//   { value: "Hadejia", label: "Hadejia", state: "Jigawa" },
//   { value: "Jahun", label: "Jahun", state: "Jigawa" },
//   { value: "Kafin Hausa", label: "Kafin Hausa", state: "Jigawa" },
//   { value: "Kaugama", label: "Kaugama", state: "Jigawa" },
//   { value: "Kazaure", label: "Kazaure", state: "Jigawa" },
//   { value: "Kiri Kasama", label: "Kiri Kasama", state: "Jigawa" },
//   { value: "Kiyawa", label: "Kiyawa", state: "Jigawa" },
//   { value: "Maigatari", label: "Maigatari", state: "Jigawa" },
//   { value: "Malam Madori", label: "Malam Madori", state: "Jigawa" },
//   { value: "Miga", label: "Miga", state: "Jigawa" },
//   { value: "Ringim", label: "Ringim", state: "Jigawa" },
//   { value: "Roni", label: "Roni", state: "Jigawa" },
//   { value: "Sule Tankarkar", label: "Sule Tankarkar", state: "Jigawa" },
//   { value: "Taura", label: "Taura", state: "Jigawa" },
//   { value: "Yankwashi", label: "Yankwashi", state: "Jigawa" },
//   { value: "Birnin Gwari", label: "Birnin Gwari", state: "Kaduna" },
//   { value: "Chikun", label: "Chikun", state: "Kaduna" },
//   { value: "Giwa", label: "Giwa", state: "Kaduna" },
//   // Kaduna State
//   { value: "Birnin Gwari", label: "Birnin Gwari", state: "Kaduna" },
//   { value: "Chikun", label: "Chikun", state: "Kaduna" },
//   { value: "Giwa", label: "Giwa", state: "Kaduna" },
//   { value: "Igabi", label: "Igabi", state: "Kaduna" },
//   { value: "Ikara", label: "Ikara", state: "Kaduna" },
//   { value: "Jaba", label: "Jaba", state: "Kaduna" },
//   { value: "Jema'a", label: "Jema'a", state: "Kaduna" },
//   { value: "Kachia", label: "Kachia", state: "Kaduna" },
//   { value: "Kaduna North", label: "Kaduna North", state: "Kaduna" },
//   { value: "Kaduna South", label: "Kaduna South", state: "Kaduna" },
//   { value: "Kagarko", label: "Kagarko", state: "Kaduna" },
//   { value: "Kajuru", label: "Kajuru", state: "Kaduna" },
//   { value: "Kaura", label: "Kaura", state: "Kaduna" },
//   { value: "Kauru", label: "Kauru", state: "Kaduna" },
//   { value: "Kubau", label: "Kubau", state: "Kaduna" },
//   { value: "Kudan", label: "Kudan", state: "Kaduna" },
//   { value: "Lere", label: "Lere", state: "Kaduna" },
//   { value: "Makarfi", label: "Makarfi", state: "Kaduna" },
//   { value: "Sabon Gari", label: "Sabon Gari", state: "Kaduna" },
//   { value: "Sanga", label: "Sanga", state: "Kaduna" },
//   { value: "Soba", label: "Soba", state: "Kaduna" },
//   { value: "Zangon Kataf", label: "Zangon Kataf", state: "Kaduna" },
//   { value: "Zaria", label: "Zaria", state: "Kaduna" },

//   // Kano State
//   { value: "Ajingi", label: "Ajingi", state: "Kano" },
//   { value: "Albasu", label: "Albasu", state: "Kano" },
//   { value: "Bagwai", label: "Bagwai", state: "Kano" },
//   { value: "Bebeji", label: "Bebeji", state: "Kano" },
//   { value: "Bichi", label: "Bichi", state: "Kano" },
//   { value: "Bunkure", label: "Bunkure", state: "Kano" },
//   { value: "Dala", label: "Dala", state: "Kano" },
//   { value: "Dambatta", label: "Dambatta", state: "Kano" },
//   { value: "Dawakin Kudu", label: "Dawakin Kudu", state: "Kano" },
//   { value: "Dawakin Tofa", label: "Dawakin Tofa", state: "Kano" },
//   { value: "Doguwa", label: "Doguwa", state: "Kano" },
//   { value: "Fagge", label: "Fagge", state: "Kano" },
//   { value: "Gabasawa", label: "Gabasawa", state: "Kano" },
//   { value: "Garko", label: "Garko", state: "Kano" },
//   { value: "Garun Mallam", label: "Garun Mallam", state: "Kano" },
//   { value: "Gaya", label: "Gaya", state: "Kano" },
//   { value: "Gezawa", label: "Gezawa", state: "Kano" },
//   { value: "Gwale", label: "Gwale", state: "Kano" },
//   { value: "Gwarzo", label: "Gwarzo", state: "Kano" },
//   { value: "Kabo", label: "Kabo", state: "Kano" },
//   { value: "Kano Municipal", label: "Kano Municipal", state: "Kano" },
//   { value: "Karaye", label: "Karaye", state: "Kano" },
//   { value: "Kibiya", label: "Kibiya", state: "Kano" },
//   { value: "Kiru", label: "Kiru", state: "Kano" },
//   { value: "Kumbotso", label: "Kumbotso", state: "Kano" },
//   { value: "Kunchi", label: "Kunchi", state: "Kano" },
//   { value: "Kura", label: "Kura", state: "Kano" },
//   { value: "Madobi", label: "Madobi", state: "Kano" },
//   { value: "Makoda", label: "Makoda", state: "Kano" },
//   { value: "Minjibir", label: "Minjibir", state: "Kano" },
//   { value: "Nasarawa", label: "Nasarawa", state: "Kano" },
//   { value: "Rano", label: "Rano", state: "Kano" },
//   { value: "Rimin Gado", label: "Rimin Gado", state: "Kano" },
//   { value: "Rogo", label: "Rogo", state: "Kano" },
//   { value: "Shanono", label: "Shanono", state: "Kano" },
//   { value: "Sumaila", label: "Sumaila", state: "Kano" },
//   { value: "Takai", label: "Takai", state: "Kano" },
//   { value: "Tarauni", label: "Tarauni", state: "Kano" },
//   { value: "Tofa", label: "Tofa", state: "Kano" },
//   { value: "Tsanyawa", label: "Tsanyawa", state: "Kano" },
//   { value: "Tudun Wada", label: "Tudun Wada", state: "Kano" },
//   { value: "Ungogo", label: "Ungogo", state: "Kano" },
//   { value: "Warawa", label: "Warawa", state: "Kano" },
//   { value: "Wudil", label: "Wudil", state: "Kano" },

//   // Katsina State
//   { value: "Bakori", label: "Bakori", state: "Katsina" },
//   { value: "Batagarawa", label: "Batagarawa", state: "Katsina" },
//   { value: "Batsari", label: "Batsari", state: "Katsina" },
//   { value: "Baure", label: "Baure", state: "Katsina" },
//   { value: "Bindawa", label: "Bindawa", state: "Katsina" },
//   { value: "Charanchi", label: "Charanchi", state: "Katsina" },
//   { value: "Dandume", label: "Dandume", state: "Katsina" },
//   { value: "Danja", label: "Danja", state: "Katsina" },
//   { value: "Dan Musa", label: "Dan Musa", state: "Katsina" },
//   { value: "Daura", label: "Daura", state: "Katsina" },
//   { value: "Dutsi", label: "Dutsi", state: "Katsina" },
//   { value: "Dutsin Ma", label: "Dutsin Ma", state: "Katsina" },
//   { value: "Faskari", label: "Faskari", state: "Katsina" },
//   { value: "Funtua", label: "Funtua", state: "Katsina" },
//   { value: "Ingawa", label: "Ingawa", state: "Katsina" },
//   { value: "Jibia", label: "Jibia", state: "Katsina" },
//   { value: "Kafur", label: "Kafur", state: "Katsina" },
//   { value: "Kaita", label: "Kaita", state: "Katsina" },
//   { value: "Kankara", label: "Kankara", state: "Katsina" },
//   { value: "Kankia", label: "Kankia", state: "Katsina" },
//   { value: "Katsina", label: "Katsina", state: "Katsina" },
//   { value: "Kurfi", label: "Kurfi", state: "Katsina" },
//   { value: "Kusada", label: "Kusada", state: "Katsina" },
//   { value: "Mai'Adua", label: "Mai'Adua", state: "Katsina" },
//   { value: "Malumfashi", label: "Malumfashi", state: "Katsina" },
//   { value: "Mani", label: "Mani", state: "Katsina" },
//   { value: "Mashi", label: "Mashi", state: "Katsina" },
//   { value: "Matazu", label: "Matazu", state: "Katsina" },
//   { value: "Musawa", label: "Musawa", state: "Katsina" },
//   { value: "Rimi", label: "Rimi", state: "Katsina" },
//   { value: "Sabuwa", label: "Sabuwa", state: "Katsina" },
//   { value: "Safana", label: "Safana", state: "Katsina" },
//   { value: "Sandamu", label: "Sandamu", state: "Katsina" },
//   { value: "Zango", label: "Zango", state: "Katsina" },

//   // Kebbi State
//   { value: "Aleiro", label: "Aleiro", state: "Kebbi" },
//   { value: "Arewa", label: "Arewa", state: "Kebbi" },
//   { value: "Argungu", label: "Argungu", state: "Kebbi" },
//   { value: "Augie", label: "Augie", state: "Kebbi" },
//   { value: "Bagudo", label: "Bagudo", state: "Kebbi" },
//   { value: "Birnin Kebbi", label: "Birnin Kebbi", state: "Kebbi" },
//   { value: "Bunza", label: "Bunza", state: "Kebbi" },
//   { value: "Dandi", label: "Dandi", state: "Kebbi" },
//   { value: "Fakai", label: "Fakai", state: "Kebbi" },
//   { value: "Gwandu", label: "Gwandu", state: "Kebbi" },
//   { value: "Jega", label: "Jega", state: "Kebbi" },
//   { value: "Kalgo", label: "Kalgo", state: "Kebbi" },

//   // Kogi State
//   { value: "Adavi", label: "Adavi", state: "Kogi" },
//   { value: "Ajaokuta", label: "Ajaokuta", state: "Kogi" },
//   { value: "Ankpa", label: "Ankpa", state: "Kogi" },
//   { value: "Bassa", label: "Bassa", state: "Kogi" },
//   { value: "Dekina", label: "Dekina", state: "Kogi" },
//   { value: "Ibaji", label: "Ibaji", state: "Kogi" },
//   { value: "Idah", label: "Idah", state: "Kogi" },
//   { value: "Igalamela/Odolu", label: "Igalamela/Odolu", state: "Kogi" },
//   { value: "Kabba/Bunu", label: "Kabba/Bunu", state: "Kogi" },
//   { value: "Mopa", label: "Mopa", state: "Kogi" },
//   { value: "Yagba West", label: "Yagba West", state: "Kogi" },
//   { value: "Yagba East", label: "Yagba East", state: "Kogi" },
//   { value: "Okene", label: "Okene", state: "Kogi" },
//   { value: "Okehi", label: "Okehi", state: "Kogi" },
//   { value: "Lokoja", label: "Lokoja", state: "Kogi" },
//   { value: "Isanlu", label: "Isanlu", state: "Kogi" },
//   { value: "Olamaboro", label: "Olamaboro", state: "Kogi" },
//   { value: "Omala", label: "Omala", state: "Kogi" },

//   // Kwara State
//   { value: "Ekiti", label: "Ekiti", state: "Kwara" },
//   { value: "Ifelodun", label: "Ifelodun", state: "Kwara" },
//   { value: "Ilorin East", label: "Ilorin East", state: "Kwara" },
//   { value: "Ilorin West", label: "Ilorin West", state: "Kwara" },
//   { value: "Irepodun", label: "Irepodun", state: "Kwara" },
//   { value: "Isin", label: "Isin", state: "Kwara" },
//   { value: "Kaiama", label: "Kaiama", state: "Kwara" },
//   { value: "Moro", label: "Moro", state: "Kwara" },
//   { value: "Offa", label: "Offa", state: "Kwara" },
//   { value: "Oke-Ero", label: "Oke-Ero", state: "Kwara" },
//   { value: "Oyun", label: "Oyun", state: "Kwara" },
//   { value: "Pategi", label: "Pategi", state: "Kwara" },
//   { value: "Baruten", label: "Baruten", state: "Kwara" },
//   { value: "Asa", label: "Asa", state: "Kwara" },
//   { value: "Omu Aran", label: "Omu Aran", state: "Kwara" },

//   // Lagos State
//   { value: "Agege", label: "Agege", state: "Lagos" },
//   { value: "Ajeromi-Ifelodun", label: "Ajeromi-Ifelodun", state: "Lagos" },
//   { value: "Alimosho", label: "Alimosho", state: "Lagos" },
//   { value: "Amuwo-Odofin", label: "Amuwo-Odofin", state: "Lagos" },
//   { value: "Apapa", label: "Apapa", state: "Lagos" },
//   { value: "Badagry", label: "Badagry", state: "Lagos" },
//   { value: "Epe", label: "Epe", state: "Lagos" },
//   { value: "Eti Osa", label: "Eti Osa", state: "Lagos" },
//   { value: "Ibeju-Lekki", label: "Ibeju-Lekki", state: "Lagos" },
//   { value: "Ifako-Ijaiye", label: "Ifako-Ijaiye", state: "Lagos" },
//   { value: "Ikeja", label: "Ikeja", state: "Lagos" },
//   { value: "Ikorodu", label: "Ikorodu", state: "Lagos" },
//   { value: "Kosofe", label: "Kosofe", state: "Lagos" },
//   { value: "Lagos Island", label: "Lagos Island", state: "Lagos" },
//   { value: "Lagos Mainland", label: "Lagos Mainland", state: "Lagos" },
//   { value: "Mushin", label: "Mushin", state: "Lagos" },
//   { value: "Ojo", label: "Ojo", state: "Lagos" },
//   { value: "Oshodi-Isolo", label: "Oshodi-Isolo", state: "Lagos" },
//   { value: "Shomolu", label: "Shomolu", state: "Lagos" },
//   { value: "Surulere", label: "Surulere", state: "Lagos" },

//   // Nasarawa State
//   { value: "Akwanga", label: "Akwanga", state: "Nasarawa" },
//   { value: "Awe", label: "Awe", state: "Nasarawa" },
//   { value: "Doma", label: "Doma", state: "Nasarawa" },
//   { value: "Karu", label: "Karu", state: "Nasarawa" },
//   { value: "Lafia", label: "Lafia", state: "Nasarawa" },
//   { value: "Keana", label: "Keana", state: "Nasarawa" },
//   { value: "Obi", label: "Obi", state: "Nasarawa" },
//   { value: "Kokona", label: "Kokona", state: "Nasarawa" },
//   { value: "Keffi", label: "Keffi", state: "Nasarawa" },
//   { value: "Nasarawa", label: "Nasarawa", state: "Nasarawa" },
//   { value: "Nasarawa Eggon", label: "Nasarawa Eggon", state: "Nasarawa" },
//   { value: "Wamba", label: "Wamba", state: "Nasarawa" },
//   { value: "Toto", label: "Toto", state: "Nasarawa" },

//   // Niger State
//   { value: "Agaie", label: "Agaie", state: "Niger" },
//   { value: "Agwara", label: "Agwara", state: "Niger" },
//   { value: "Bida", label: "Bida", state: "Niger" },
//   { value: "Borgu", label: "Borgu", state: "Niger" },
//   { value: "Bosso", label: "Bosso", state: "Niger" },
//   { value: "Chanchaga", label: "Chanchaga", state: "Niger" },
//   { value: "Edati", label: "Edati", state: "Niger" },
//   { value: "Gbako", label: "Gbako", state: "Niger" },
//   { value: "Gurara", label: "Gurara", state: "Niger" },
//   { value: "Katcha", label: "Katcha", state: "Niger" },
//   { value: "Kontagora", label: "Kontagora", state: "Niger" },
//   { value: "Lapai", label: "Lapai", state: "Niger" },
//   { value: "Lavun", label: "Lavun", state: "Niger" },
//   { value: "Magama", label: "Magama", state: "Niger" },
//   { value: "Mariga", label: "Mariga", state: "Niger" },
//   { value: "Mashegu", label: "Mashegu", state: "Niger" },
//   { value: "Mokwa", label: "Mokwa", state: "Niger" },
//   { value: "Munya", label: "Munya", state: "Niger" },
//   { value: "Paikoro", label: "Paikoro", state: "Niger" },
//   { value: "Rafi", label: "Rafi", state: "Niger" },
//   { value: "Rijau", label: "Rijau", state: "Niger" },
//   { value: "Shiroro", label: "Shiroro", state: "Niger" },
//   { value: "Suleja", label: "Suleja", state: "Niger" },
//   { value: "Tafa", label: "Tafa", state: "Niger" },
//   { value: "Wushishi", label: "Wushishi", state: "Niger" },

//   // Ogun State
//   { value: "Abeokuta North", label: "Abeokuta North", state: "Ogun" },
//   { value: "Abeokuta South", label: "Abeokuta South", state: "Ogun" },
//   { value: "Ado-Odo/Ota", label: "Ado-Odo/Ota", state: "Ogun" },
//   { value: "Ewekoro", label: "Ewekoro", state: "Ogun" },
//   { value: "Ifo", label: "Ifo", state: "Ogun" },
//   { value: "Ijebu North", label: "Ijebu North", state: "Ogun" },
//   { value: "Ijebu North East", label: "Ijebu North East", state: "Ogun" },
//   { value: "Ijebu Ode", label: "Ijebu Ode", state: "Ogun" },
//   { value: "Ijebu East", label: "Ijebu East", state: "Ogun" },
//   { value: "Ilisan-Remo", label: "Ilisan-Remo", state: "Ogun" },
//   { value: "Ikenne", label: "Ikenne", state: "Ogun" },
//   { value: "Imeko Afon", label: "Imeko Afon", state: "Ogun" },
//   { value: "Ipokia", label: "Ipokia", state: "Ogun" },
//   { value: "Obafemi Owode", label: "Obafemi Owode", state: "Ogun" },
//   { value: "Odeda", label: "Odeda", state: "Ogun" },
//   { value: "Odogbolu", label: "Odogbolu", state: "Ogun" },
//   { value: "Ogun Waterside", label: "Ogun Waterside", state: "Ogun" },
//   { value: "Remo North", label: "Remo North", state: "Ogun" },
//   { value: "Shagamu", label: "Shagamu", state: "Ogun" },
//   { value: "Yewa North", label: "Yewa North", state: "Ogun" },
//   { value: "Yewa South", label: "Yewa South", state: "Ogun" },

//   // Ondo State
//   { value: "Akoko North-East", label: "Akoko North-East", state: "Ondo" },
//   { value: "Akoko North-West", label: "Akoko North-West", state: "Ondo" },
//   { value: "Akoko South-East", label: "Akoko South-East", state: "Ondo" },
//   { value: "Akoko South-West", label: "Akoko South-West", state: "Ondo" },
//   { value: "Akure North", label: "Akure North", state: "Ondo" },
//   { value: "Akure South", label: "Akure South", state: "Ondo" },
//   { value: "Ese Odo", label: "Ese Odo", state: "Ondo" },
//   { value: "Ifedore", label: "Ifedore", state: "Ondo" },
//   { value: "Idanre", label: "Idanre", state: "Ondo" },
//   { value: "Ilaje", label: "Ilaje", state: "Ondo" },
//   { value: "Ile-Oluji/Okeigbo", label: "Ile-Oluji/Okeigbo", state: "Ondo" },
//   { value: "Irele", label: "Irele", state: "Ondo" },
//   { value: "Odigbo", label: "Odigbo", state: "Ondo" },
//   { value: "Okitipupa", label: "Okitipupa", state: "Ondo" },
//   { value: "Ondo West", label: "Ondo West", state: "Ondo" },
//   { value: "Ondo East", label: "Ondo East", state: "Ondo" },
//   { value: "Ose", label: "Ose", state: "Ondo" },
//   { value: "Owo", label: "Owo", state: "Ondo" },

//   // Osun State
//   { value: "Aiyedaade", label: "Aiyedaade", state: "Osun" },
//   { value: "Aiyedire", label: "Aiyedire", state: "Osun" },
//   { value: "Atakunmosa East", label: "Atakunmosa East", state: "Osun" },
//   { value: "Atakunmosa West", label: "Atakunmosa West", state: "Osun" },
//   { value: "Boluwaduro", label: "Boluwaduro", state: "Osun" },
//   { value: "Boripe", label: "Boripe", state: "Osun" },
//   { value: "Ede North", label: "Ede North", state: "Osun" },
//   { value: "Ede South", label: "Ede South", state: "Osun" },
//   { value: "Egbedore", label: "Egbedore", state: "Osun" },
//   { value: "Ejigbo", label: "Ejigbo", state: "Osun" },
//   { value: "Ife Central", label: "Ife Central", state: "Osun" },
//   { value: "Ife East", label: "Ife East", state: "Osun" },
//   { value: "Ife North", label: "Ife North", state: "Osun" },
//   { value: "Ife South", label: "Ife South", state: "Osun" },
//   { value: "Ifedayo", label: "Ifedayo", state: "Osun" },
//   { value: "Ifelodun", label: "Ifelodun", state: "Osun" },
//   { value: "Isokan", label: "Isokan", state: "Osun" },
//   { value: "Obokun", label: "Obokun", state: "Osun" },
//   { value: "Irewole", label: "Irewole", state: "Osun" },
//   { value: "Ola-Oluwa", label: "Ola-Oluwa", state: "Osun" },
//   { value: "Olorunda", label: "Olorunda", state: "Osun" },
//   { value: "Ilesa West", label: "Ilesa West", state: "Osun" },
//   { value: "Ilesa East", label: "Ilesa East", state: "Osun" },
//   { value: "Odo-Otin", label: "Odo-Otin", state: "Osun" },
//   { value: "Ila", label: "Ila", state: "Osun" },
//   { value: "Ori-Ade", label: "Ori-Ade", state: "Osun" },
//   { value: "Orolu", label: "Orolu", state: "Osun" },
//   { value: "Irepodun", label: "Irepodun", state: "Osun" },
//   { value: "Iwo", label: "Iwo", state: "Osun" },
//   { value: "Osogbo", label: "Osogbo", state: "Osun" },

//   // Oyo State
//   { value: "Afijio", label: "Afijio", state: "Oyo" },
//   { value: "Ibadan North", label: "Ibadan North", state: "Oyo" },
//   { value: "Ibadan North-East", label: "Ibadan North-East", state: "Oyo" },
//   { value: "Ibadan North-West", label: "Ibadan North-West", state: "Oyo" },
//   { value: "Ibadan South-East", label: "Ibadan South-East", state: "Oyo" },
//   { value: "Ibadan South-West", label: "Ibadan South-West", state: "Oyo" },
//   { value: "Ibarapa Central", label: "Ibarapa Central", state: "Oyo" },
//   { value: "Ibarapa East", label: "Ibarapa East", state: "Oyo" },
//   { value: "Ibarapa North", label: "Ibarapa North", state: "Oyo" },
//   { value: "Ido", label: "Ido", state: "Oyo" },
//   { value: "Irepo", label: "Irepo", state: "Oyo" },
//   { value: "Iwajowa", label: "Iwajowa", state: "Oyo" },
//   { value: "Ogbomosho North", label: "Ogbomosho North", state: "Oyo" },
//   { value: "Ogbomosho South", label: "Ogbomosho South", state: "Oyo" },
//   { value: "Ogo Oluwa", label: "Ogo Oluwa", state: "Oyo" },
//   { value: "Olorunsogo", label: "Olorunsogo", state: "Oyo" },
//   { value: "Oluyole", label: "Oluyole", state: "Oyo" },
//   { value: "Ona Ara", label: "Ona Ara", state: "Oyo" },
//   { value: "Orelope", label: "Orelope", state: "Oyo" },
//   { value: "Atisbo", label: "Atisbo", state: "Oyo" },
//   { value: "Saki-west", label: "Saki-west", state: "Oyo" },
//   { value: "Saki-east", label: "Saki-east", state: "Oyo" },
//   { value: "Egbeda", label: "Egbeda", state: "Oyo" },
//   { value: "Lagelu", label: "Lagelu", state: "Oyo" },
//   { value: "Atiba", label: "Atiba", state: "Oyo" },
//   { value: "Oyo East", label: "Oyo East", state: "Oyo" },
//   { value: "Oyo West", label: "Oyo West", state: "Oyo" },

//   // Plateau State
//   { value: "Barkin Ladi", label: "Barkin Ladi", state: "Plateau" },
//   { value: "Bassa", label: "Bassa", state: "Plateau" },
//   { value: "Bokkos", label: "Bokkos", state: "Plateau" },
//   { value: "Jos East", label: "Jos East", state: "Plateau" },
//   { value: "Jos North", label: "Jos North", state: "Plateau" },
//   { value: "Jos South", label: "Jos South", state: "Plateau" },
//   { value: "Kanam", label: "Kanam", state: "Plateau" },
//   { value: "Kanke", label: "Kanke", state: "Plateau" },
//   { value: "Langtang North", label: "Langtang North", state: "Plateau" },
//   { value: "Langtang South", label: "Langtang South", state: "Plateau" },
//   { value: "Mangu", label: "Mangu", state: "Plateau" },
//   { value: "Mikang", label: "Mikang", state: "Plateau" },
//   { value: "Pankshin", label: "Pankshin", state: "Plateau" },
//   { value: "Quaran Pan", label: "Quaran Pan", state: "Plateau" },
//   { value: "Riyom", label: "Riyom", state: "Plateau" },
//   { value: "Shendam", label: "Shendam", state: "Plateau" },
//   { value: "Wase", label: "Wase", state: "Plateau" },

//   // Rivers State
//   { value: "Abua-Odual", label: "Abua-Odual", state: "Rivers" },
//   { value: "Ahoada East", label: "Ahoada East", state: "Rivers" },
//   { value: "Ahoada West", label: "Ahoada West", state: "Rivers" },
//   { value: "Akuku Toru", label: "Akuku Toru", state: "Rivers" },
//   { value: "Andoni", label: "Andoni", state: "Rivers" },
//   { value: "Asari Toru", label: "Asari Toru", state: "Rivers" },
//   { value: "Bonny", label: "Bonny", state: "Rivers" },
//   { value: "Degema", label: "Degema", state: "Rivers" },
//   { value: "Eleme", label: "Eleme", state: "Rivers" },
//   { value: "Emohua", label: "Emohua", state: "Rivers" },
//   { value: "Etche", label: "Etche", state: "Rivers" },
//   { value: "Gokana", label: "Gokana", state: "Rivers" },
//   { value: "Ikwerre", label: "Ikwerre", state: "Rivers" },
//   { value: "Khana", label: "Khana", state: "Rivers" },
//   { value: "Obio-Akpor", label: "Obio-Akpor", state: "Rivers" },
//   { value: "Ogba-Egbema-Ndoni", label: "Ogba-Egbema-Ndoni", state: "Rivers" },
//   { value: "Ogu-Bolo", label: "Ogu-Bolo", state: "Rivers" },
//   { value: "Okirika", label: "Okirika", state: "Rivers" },
//   { value: "Omuma", label: "Omuma", state: "Rivers" },
//   { value: "Opobo-Nkoro", label: "Opobo-Nkoro", state: "Rivers" },
//   { value: "Oyigbo", label: "Oyigbo", state: "Rivers" },
//   { value: "Port Harcourt", label: "Port Harcourt", state: "Rivers" },
//   { value: "Tai", label: "Tai", state: "Rivers" },
//   // Sokoto State
//   { value: "Binji", label: "Binji", state: "Sokoto" },
//   { value: "Bodinga", label: "Bodinga", state: "Sokoto" },
//   { value: "Dange Shuni", label: "Dange Shuni", state: "Sokoto" },
//   { value: "Gada", label: "Gada", state: "Sokoto" },
//   { value: "Sokoto South", label: "Sokoto South", state: "Sokoto" },
//   { value: "Sokoto North", label: "Sokoto North", state: "Sokoto" },
//   { value: "Gwadabawa", label: "Gwadabawa", state: "Sokoto" },
//   { value: "Wamakko", label: "Wamakko", state: "Sokoto" },
//   { value: "Tangaza", label: "Tangaza", state: "Sokoto" },
//   { value: "Sabon Birni", label: "Sabon Birni", state: "Sokoto" },
//   { value: "Isah", label: "Isah", state: "Sokoto" },

//   // Taraba State
//   { value: "Ardo Kola", label: "Ardo Kola", state: "Taraba" },
//   { value: "Bali", label: "Bali", state: "Taraba" },
//   { value: "Donga", label: "Donga", state: "Taraba" },
//   { value: "Gashaka", label: "Gashaka", state: "Taraba" },
//   { value: "Gassol", label: "Gassol", state: "Taraba" },
//   { value: "Ibi", label: "Ibi", state: "Taraba" },
//   { value: "Jalingo", label: "Jalingo", state: "Taraba" },
//   { value: "Karim Lamido", label: "Karim Lamido", state: "Taraba" },
//   { value: "Kurmi", label: "Kurmi", state: "Taraba" },
//   { value: "Lau", label: "Lau", state: "Taraba" },
//   { value: "Sardauna", label: "Sardauna", state: "Taraba" },
//   { value: "Takum", label: "Takum", state: "Taraba" },
//   { value: "Ussa", label: "Ussa", state: "Taraba" },
//   { value: "Wukari", label: "Wukari", state: "Taraba" },
//   { value: "Yorro", label: "Yorro", state: "Taraba" },
//   { value: "Zing", label: "Zing", state: "Taraba" },

//   // Yobe State
//   { value: "Bade", label: "Bade", state: "Yobe" },
//   { value: "Bursari", label: "Bursari", state: "Yobe" },
//   { value: "Damaturu", label: "Damaturu", state: "Yobe" },
//   { value: "Fika", label: "Fika", state: "Yobe" },
//   { value: "Fune", label: "Fune", state: "Yobe" },
//   { value: "Geidam", label: "Geidam", state: "Yobe" },
//   { value: "Gujba", label: "Gujba", state: "Yobe" },
//   { value: "Gulani", label: "Gulani", state: "Yobe" },
//   { value: "Jakusko", label: "Jakusko", state: "Yobe" },
//   { value: "Karasuwa", label: "Karasuwa", state: "Yobe" },
//   { value: "Machina", label: "Machina", state: "Yobe" },
//   { value: "Nangere", label: "Nangere", state: "Yobe" },
//   { value: "Nguru", label: "Nguru", state: "Yobe" },
//   { value: "Potiskum", label: "Potiskum", state: "Yobe" },
//   { value: "Tarmuwa", label: "Tarmuwa", state: "Yobe" },
//   { value: "Yunusari", label: "Yunusari", state: "Yobe" },
//   { value: "Yusufari", label: "Yusufari", state: "Yobe" },

//   // Zamfara State
//   { value: "Anka", label: "Anka", state: "Zamfara" },
//   { value: "Bakura", label: "Bakura", state: "Zamfara" },
//   { value: "Bukkuyum", label: "Bukkuyum", state: "Zamfara" },
//   { value: "Bungudu", label: "Bungudu", state: "Zamfara" },
//   { value: "Tsafe", label: "Tsafe", state: "Zamfara" },
//   { value: "Gummi", label: "Gummi", state: "Zamfara" },
//   { value: "Gusau", label: "Gusau", state: "Zamfara" },
//   { value: "Kaura Namoda", label: "Kaura Namoda", state: "Zamfara" },
//   { value: "Maradun", label: "Maradun", state: "Zamfara" },
//   { value: "Maru", label: "Maru", state: "Zamfara" },
//   { value: "Shinkafi", label: "Shinkafi", state: "Zamfara" },
//   { value: "Talata Mafara", label: "Talata Mafara", state: "Zamfara" },
//   { value: "Zurmi", label: "Zurmi", state: "Zamfara" },

//   // Federal Capital Territory
//   { value: "Abaji", label: "Abaji", state: "FCT" },
//   {
//     value: "Abuja Municipal",
//     label: "Abuja Municipal",
//     state: "FCT",
//   },
//   { value: "Bwari", label: "Bwari", state: "FCT" },
//   {
//     value: "Gwagwalada",
//     label: "Gwagwalada",
//     state: "FCT",
//   },
//   { value: "Kuje", label: "Kuje", state: "FCT" },
//   { value: "Kwali", label: "Kwali", state: "FCT" },
// ];
